import { GeneratedBuildData } from 'web/data/models'

export const GENERATED_MAIN: GeneratedBuildData = JSON.parse(`{
    "changelog": [
      "- Disc - Remove Rapture",
      "- MW - Change Chiji/Yulon to 2min baseline",
      "- Shaman - Remove Ancestral Guidance",
      "TWW S2"
    ],
    "modifiersById": {
      "068f6ed7-c9ef-413e-a447-f7d779ad9aa1": {
        "eligibleSpecIds": [
          "0c9d68bc-e126-4a07-817a-72c37094e005",
          "2fed59fd-6bdc-4b4e-a7d6-70c70cf8a5aa",
          "34b5a797-05ef-4431-91a0-64cc76a97624"
        ],
        "game_id": 53271,
        "icon_name": "ability_hunter_masterscall",
        "id": "068f6ed7-c9ef-413e-a447-f7d779ad9aa1",
        "meta": "",
        "name": "Master's Call",
        "shortName": "Call"
      }
    },
    "patchInfo": {
      "buildVersion": "1110_1"
    },
    "specsById": {
      "08853913-0c47-4ca1-aec0-e93206a6ee45": {
        "classId": "122a0a6d-d523-4cc2-a743-f3d42d3e7f02",
        "icon_name": "ability_demonhunter_specdps",
        "id": "08853913-0c47-4ca1-aec0-e93206a6ee45",
        "name": "Havoc",
        "role": "Melee DPS",
        "shortName": "Havoc",
        "spellIds": [
          "9ba548ea-fc82-4d61-9b01-3cde12d48716"
        ],
        "talentIds": [
          "21fbcd60-b5fa-4da4-ba8f-323f142dcecf",
          "e9241746-c3b9-48f3-8f59-3e44529f8c44"
        ]
      },
      "0c9d68bc-e126-4a07-817a-72c37094e005": {
        "classId": "0a3fc2d5-66d5-42da-abc4-2bfbcf5bc9b3",
        "icon_name": "ability_hunter_camouflage",
        "id": "0c9d68bc-e126-4a07-817a-72c37094e005",
        "name": "Survival",
        "role": "Melee DPS",
        "shortName": "Surv",
        "spellIds": [
          "57aa024a-6536-49c2-aa2a-12c61ce500de",
          "ad2ca623-1ce1-4436-ad84-68766ef45c35"
        ],
        "talentIds": [
          "5ae9580e-cb49-4e4f-aa6d-9d17c56aaf38"
        ]
      },
      "18dad85c-ac2c-4aac-b0f8-e0fc4b8633e6": {
        "classId": "9223f4e8-8669-451e-815a-d53a19416c5a",
        "icon_name": "spell_monk_brewmaster_spec",
        "id": "18dad85c-ac2c-4aac-b0f8-e0fc4b8633e6",
        "name": "Brewmaster",
        "role": "Tank",
        "shortName": "BRM",
        "spellIds": [
          "22d28f2e-4543-4754-a890-a76d3a49a548",
          "5070b303-2953-4a55-bb51-a0bd8344fe09"
        ],
        "talentIds": [
          "0664d053-620c-4a9a-8b81-b5708d613ecd",
          "b46075fb-d3c3-4057-82ee-936233ed4ab1"
        ]
      },
      "1b478900-c50e-49f6-b9b1-d2fedfb10c2b": {
        "classId": "532f16f1-1e8b-4aba-af5d-17b292fc05fd",
        "icon_name": "spell_deathknight_unholypresence",
        "id": "1b478900-c50e-49f6-b9b1-d2fedfb10c2b",
        "name": "Unholy",
        "role": "Melee DPS",
        "shortName": "Unholy",
        "spellIds": [
          "279e6146-898b-482f-9b99-a74845c191ac",
          "743faca6-fb16-43a3-90b7-0362bbb0145f"
        ],
        "talentIds": [
          "1db88ec3-6ff2-45a0-9d6d-3f6565666ec5",
          "d51b0c37-a48f-4c9c-ab59-5056cccd2c97"
        ]
      },
      "1df0b300-a31e-4ebc-be57-a909f82bab4b": {
        "classId": "d599cd61-11ae-4a4d-a856-60d1c7f4572d",
        "icon_name": "spell_nature_lightning",
        "id": "1df0b300-a31e-4ebc-be57-a909f82bab4b",
        "name": "Elemental",
        "role": "Ranged DPS",
        "shortName": "Ele",
        "spellIds": [
          "1d81f543-080f-4afa-8232-35b3c41450a7",
          "f1ce058f-96aa-412b-a8da-14fc74d5c6f8"
        ],
        "talentIds": [
          "209202d5-1098-4b82-a57d-c9fb9b2fa3bc",
          "3132878e-6050-46fa-8123-34b4140cc5a6",
          "39b7ba4f-f3f1-4c88-9869-2d19d08b6722",
          "661685eb-b5c8-4805-9a1b-f243c3d7d207",
          "b42a618a-6020-4766-8fbb-8427b0589f3e"
        ]
      },
      "1fcfbc91-0ad8-4c1d-ab1a-ff9424abc17d": {
        "classId": "0a450e25-065c-4c3c-a881-cea74cf08462",
        "icon_name": "ability_warrior_innerrage",
        "id": "1fcfbc91-0ad8-4c1d-ab1a-ff9424abc17d",
        "name": "Fury",
        "role": "Melee DPS",
        "shortName": "Fury",
        "spellIds": [
          "5a29401a-fc11-4cfd-8ea2-3ffd2bc73a05"
        ],
        "talentIds": []
      },
      "2fed59fd-6bdc-4b4e-a7d6-70c70cf8a5aa": {
        "classId": "0a3fc2d5-66d5-42da-abc4-2bfbcf5bc9b3",
        "icon_name": "ability_hunter_bestialdiscipline",
        "id": "2fed59fd-6bdc-4b4e-a7d6-70c70cf8a5aa",
        "name": "Beast Mastery",
        "role": "Ranged DPS",
        "shortName": "BM",
        "spellIds": [
          "42339fbf-de98-4081-a66b-68958bcb3246",
          "4e56230b-e5a3-4799-8429-a08086373c1e"
        ],
        "talentIds": [
          "feafa380-c709-4caf-8764-32653034cacd"
        ]
      },
      "34735ecf-bf9e-4225-bb6e-ee617b024b70": {
        "classId": "532f16f1-1e8b-4aba-af5d-17b292fc05fd",
        "icon_name": "spell_deathknight_bloodpresence",
        "id": "34735ecf-bf9e-4225-bb6e-ee617b024b70",
        "name": "Blood",
        "role": "Tank",
        "shortName": "Blood",
        "spellIds": [
          "41702c8c-996b-4e69-aabe-fb6a9af6b7bf",
          "e04f6bed-54d6-4ccd-b284-fd5302e98106",
          "e793cd57-8d6b-450d-922f-b7f8ecdaccde"
        ],
        "talentIds": [
          "6e4d7e5b-8a41-4dae-aca0-5ba062d951f9",
          "a1a9d9f5-3e80-42d8-a698-790f5483e233",
          "ddf5e9b4-563c-489c-9e2c-969ef9137d90",
          "ef60d47b-0057-4d36-b70e-2da0c78f7f60"
        ]
      },
      "34b5a797-05ef-4431-91a0-64cc76a97624": {
        "classId": "0a3fc2d5-66d5-42da-abc4-2bfbcf5bc9b3",
        "icon_name": "ability_hunter_focusedaim",
        "id": "34b5a797-05ef-4431-91a0-64cc76a97624",
        "name": "Marksman",
        "role": "Ranged DPS",
        "shortName": "Mark",
        "spellIds": [
          "354aaa0a-f46d-4cea-9226-7a9be0c05723",
          "a72746bd-e803-49a0-9563-7aa61ba66a4e"
        ],
        "talentIds": [
          "0681053e-7a87-42d2-bbb6-3040dec74a0f"
        ]
      },
      "3f5cbe75-0a0e-4406-90a7-d46833c9fca2": {
        "classId": "5b6efded-e5dd-4429-adfd-2c6d3893e678",
        "icon_name": "ability_rogue_waylay",
        "id": "3f5cbe75-0a0e-4406-90a7-d46833c9fca2",
        "name": "Outlaw",
        "role": "Melee DPS",
        "shortName": "Outlaw",
        "spellIds": [],
        "talentIds": []
      },
      "48a205f0-5e24-4382-9e0b-3c06cfc1b873": {
        "classId": "fabd40be-24a8-4b80-8445-416b6e77e15f",
        "icon_name": "classicon_evoker_preservation",
        "id": "48a205f0-5e24-4382-9e0b-3c06cfc1b873",
        "name": "Preservation",
        "role": "Healer",
        "shortName": "Pres",
        "spellIds": [
          "0be1c70c-7f60-4a80-b494-6c6c02ce1256",
          "141b3ae0-2175-4c92-b384-f7503a15fc2a",
          "4f0bef06-d8f2-4edf-aa0d-03b071ad0ad9",
          "72221d65-18bb-432a-a706-016ea5dd5dc2",
          "a7771e1d-ef0b-476b-9364-8f0b6c8b5a74",
          "a96abc8d-2053-4c85-ad04-86337dbee19e",
          "e3e67a81-8897-4358-a78e-a9d2f4a052f4",
          "e8c809f2-403c-4a1c-931d-3d098d0b4be4"
        ],
        "talentIds": [
          "3725d5f9-9f0d-4247-b601-593641f2b400",
          "60d405ec-59b6-412a-930e-ae796cc44bab",
          "69be9306-608e-4446-be1e-cc51ea80988d",
          "b1b64ce1-49d1-4fa5-b047-fc83e85a6f49",
          "b1e5d8b2-8f03-4c56-87bc-168b78983f05",
          "c788d9cb-8e85-432b-8ec4-763fc36d75bd",
          "d3313379-f52e-4693-8d02-2ff8414771e2",
          "e0ed8a5e-e384-490e-bae8-b0bbe94ccf3f"
        ]
      },
      "48c27d79-2cc2-4674-bfd0-9a471f6c7ced": {
        "classId": "f3899285-de29-4692-a640-98b5d03579ee",
        "icon_name": "spell_shadow_shadowwordpain",
        "id": "48c27d79-2cc2-4674-bfd0-9a471f6c7ced",
        "name": "Shadow",
        "role": "Ranged DPS",
        "shortName": "Shadow",
        "spellIds": [
          "25555cd2-b57a-42c1-80ff-98d9025d59a1",
          "c93d1c28-2dae-4e36-a5a0-cea6186e46e8",
          "ed3afda4-ab7a-4d18-8768-197c47df876c"
        ],
        "talentIds": [
          "2b72b7a8-5225-4cf8-9869-e155b771c0ab",
          "34f9cd41-943d-4938-b700-487a4ae91dc6",
          "86967fd5-a1d9-4a28-95ba-4726fbd78e88",
          "e4110ee3-e5be-4e09-aa25-e580a7b09d97",
          "ec0aae17-7c9c-4335-9bbe-54e56e5deb9b"
        ]
      },
      "4ac0a1e4-3352-49e9-b455-faa83312526d": {
        "classId": "d056557a-1414-4958-b859-11656dfc0528",
        "icon_name": "spell_holy_auraoflight",
        "id": "4ac0a1e4-3352-49e9-b455-faa83312526d",
        "name": "Retribution",
        "role": "Melee DPS",
        "shortName": "Ret",
        "spellIds": [
          "24b79c04-7217-492e-aca6-4500fa80124c",
          "38fd80ac-1990-4a29-845f-622648797f07",
          "cb77a43e-809f-4e05-84ad-9c81db717cd7",
          "f9c6752f-572b-4279-a184-2ebb993610b6"
        ],
        "talentIds": [
          "5e19c74d-51bf-4a6c-b4ae-4062092545c7",
          "9d3e0934-fd24-4548-8e98-24b15b3a7724",
          "bf99cae6-ff7b-4020-83c5-01405fe3869f",
          "c5c5d3c7-4bb0-45d7-b7e7-13d3b945a3fd",
          "e30f64db-ddce-4fee-8770-e0db405b5e02"
        ]
      },
      "51daa0f0-df16-4983-ae44-e11b5f9b3edb": {
        "classId": "d599cd61-11ae-4a4d-a856-60d1c7f4572d",
        "icon_name": "spell_nature_magicimmunity",
        "id": "51daa0f0-df16-4983-ae44-e11b5f9b3edb",
        "name": "Restoration",
        "role": "Healer",
        "shortName": "Resto",
        "spellIds": [
          "030b5e2c-d6ff-4998-84d5-9f90184dfab2",
          "5591738a-9f04-4847-9437-dbfdbc6fedf3",
          "9d80835a-52b9-4d35-a86b-576000445c02",
          "a86cff5e-78d8-4e88-8415-e2455108e044",
          "dad553bd-8fd7-424f-aec1-2deb23df82d1",
          "e8db7730-679d-4b50-947c-73256902fb94",
          "fd916eb4-325b-407a-88bf-0edf172a5e76"
        ],
        "talentIds": [
          "3199ce60-fc5a-401e-a04a-ff6c16d09c8a",
          "323aa9a7-d433-40b0-a1e0-4ec13062af41",
          "5ce5c461-8ec9-4c67-84e7-14c9c4a49c91",
          "5f356c9e-aa59-4134-ba94-ba4e0eb365d3",
          "b0609c1f-80fb-4d7e-8575-748119151e7c",
          "c207d1a2-cfde-4750-b925-21ebeb963f95",
          "c51067a1-5b8b-4e69-a1fe-fba2b257a695",
          "d00ae128-a28d-45d4-a73a-933972f4d8e7",
          "d85b4fbd-e95e-4f19-be78-5060b4ed84dd",
          "dcc7c4b8-754b-48bf-b32b-f7962a361640"
        ]
      },
      "575905ae-cdc7-44c8-946c-861d50111b6d": {
        "classId": "3667f06e-ab4c-4b9d-8fd0-c6640ad86486",
        "icon_name": "ability_druid_catform",
        "id": "575905ae-cdc7-44c8-946c-861d50111b6d",
        "name": "Feral",
        "role": "Melee DPS",
        "shortName": "Feral",
        "spellIds": [
          "01c21fba-6d03-4334-a79a-d34aa45baec4",
          "8f42a93f-7c02-426f-8096-4278e67a6cd7",
          "e9f4a649-58c3-48e2-b922-61319b1a97d8",
          "fa3e4f83-f25b-4123-aec6-5f3585937938"
        ],
        "talentIds": [
          "23a727ed-218c-4d15-ab63-59c52a812cc3",
          "583c8125-aa0f-4233-b00e-148483c8f430",
          "69827ab3-42ef-4913-a09e-b923d37bf960",
          "c50dc21e-810f-40a8-b0d3-2253e8bb292f"
        ]
      },
      "67a45712-192e-4916-ad57-d9a13124fea6": {
        "classId": "f3899285-de29-4692-a640-98b5d03579ee",
        "icon_name": "spell_holy_powerwordshield",
        "id": "67a45712-192e-4916-ad57-d9a13124fea6",
        "name": "Discipline",
        "role": "Healer",
        "shortName": "Disc",
        "spellIds": [
          "0068e949-b039-4f31-b7de-b63aff00e4e5",
          "0ede88ec-4877-4d9e-aee2-6d9d71055425",
          "1ee4bd80-9de9-49cd-94c4-93e1b64de6d4",
          "34515fa9-70f9-4a82-ba89-262b8d67c19d",
          "3599c0ce-cfa3-4434-b1c8-7e2987ac9de9",
          "9a95da74-4439-407b-a567-97c3591eac6d",
          "9a9918e7-a2f8-4a5c-a8fa-9e8698ab05dd",
          "ab58a974-2629-4cb5-8248-ebe20b7074ab",
          "d6c91c73-29d6-4f19-924a-ac4c629e7ac0"
        ],
        "talentIds": [
          "55d279c4-3b32-48bc-afe6-fba03504e6f8",
          "785b2684-c8e9-49d8-bc0d-345e37f22848",
          "86a57591-e264-4ff6-8343-effad90ccf46",
          "abdf54fd-3107-4769-a046-45fc47709cf8",
          "dbd77078-c13d-4698-9837-255c458b30dd",
          "ee0197a0-eea0-4861-a223-c460b28c64a7"
        ]
      },
      "6c233e8c-5bd4-4ece-9fb8-529a1e78759b": {
        "classId": "3667f06e-ab4c-4b9d-8fd0-c6640ad86486",
        "icon_name": "spell_nature_starfall",
        "id": "6c233e8c-5bd4-4ece-9fb8-529a1e78759b",
        "name": "Balance",
        "role": "Ranged DPS",
        "shortName": "Balance",
        "spellIds": [
          "2ab4cecf-5bbc-4af0-b1e6-136266ac36eb",
          "9e2c4cba-a1df-4717-bf0f-452654fc4903",
          "b594d808-ad9d-441b-9f63-35d573a6f708",
          "c5f94a83-5f36-4eee-98c3-188b3d977604"
        ],
        "talentIds": [
          "19b8b476-3bf6-4ea2-8c39-78421f6a4c42",
          "6467fbd3-c882-4737-a3b0-eb61173588d0",
          "816c9398-85be-4d6d-b2ff-9e47a9a5a259",
          "92a8ac6f-8d82-497b-a7be-8cb4dfc35493"
        ]
      },
      "72947601-4270-4e1e-b917-25aacaa6d3e0": {
        "classId": "3667f06e-ab4c-4b9d-8fd0-c6640ad86486",
        "icon_name": "spell_nature_healingtouch",
        "id": "72947601-4270-4e1e-b917-25aacaa6d3e0",
        "name": "Restoration",
        "role": "Healer",
        "shortName": "Resto",
        "spellIds": [
          "462666f3-b5f0-4dd0-806c-58d95be98dda",
          "784675e5-92e8-4ec6-96cb-792cad54ce1a",
          "addb8673-43ef-48e5-b6d2-d8bb92bb4cdd",
          "aeba0c47-70cf-4fd4-a69e-785cb2e608b7",
          "b844ccd9-91d9-4c22-90a6-53ecb5fe87be",
          "ec902111-72bb-4274-9d26-ac9e525cdba3"
        ],
        "talentIds": [
          "20669b18-9b9c-4a70-8897-7d2d78dbbd9c",
          "276404dc-75ba-4a51-ab87-e243c200c27c",
          "68c4840d-d722-4111-9259-d609d2a47a8d",
          "7aa9aea3-7f0e-4875-9ef6-04e6ccabcfde",
          "a850f1e4-51d9-4019-93a6-1d2fbc9b07f3",
          "b8dd12bc-a02a-4619-b322-a3443f2ae2c7",
          "e7212970-f5d7-4249-80a0-a32a19a13c9a"
        ]
      },
      "7f8d7fab-f5cc-4d47-9212-565bab25aeed": {
        "classId": "843ce836-b215-488f-b73b-d08e3904ddca",
        "icon_name": "spell_fire_firebolt02",
        "id": "7f8d7fab-f5cc-4d47-9212-565bab25aeed",
        "name": "Fire",
        "role": "Ranged DPS",
        "shortName": "Fire",
        "spellIds": [
          "4bae75e8-50ef-492c-96a2-c3287a54768d"
        ],
        "talentIds": [
          "07cab4a9-2332-45e0-a119-728f2fa001ad"
        ]
      },
      "83b7651d-c296-4a15-9932-b4012144b6ec": {
        "classId": "0a450e25-065c-4c3c-a881-cea74cf08462",
        "icon_name": "ability_warrior_defensivestance",
        "id": "83b7651d-c296-4a15-9932-b4012144b6ec",
        "name": "Protection",
        "role": "Tank",
        "shortName": "Prot",
        "spellIds": [
          "1260da03-81c4-41cc-a693-addcd98c067f"
        ],
        "talentIds": []
      },
      "88f4a6b5-7766-41c3-b824-fbba531a2c8e": {
        "classId": "9223f4e8-8669-451e-815a-d53a19416c5a",
        "icon_name": "spell_monk_windwalker_spec",
        "id": "88f4a6b5-7766-41c3-b824-fbba531a2c8e",
        "name": "Windwalker",
        "role": "Melee DPS",
        "shortName": "WW",
        "spellIds": [
          "1a034bc0-02b1-4222-bd49-abdbd49de23c",
          "47dca887-ece0-458e-a98d-6ac8dc58a775"
        ],
        "talentIds": [
          "536d0677-f2da-4049-a994-781dc6f0fdb5",
          "7ed586dd-19c5-46e7-be0e-0bd9b4564584",
          "bff86c49-be3e-4c8e-98da-39165ff143cf"
        ]
      },
      "8fceebcc-a93b-4692-81ea-331b2e59d43d": {
        "classId": "d056557a-1414-4958-b859-11656dfc0528",
        "icon_name": "ability_paladin_shieldofthetemplar",
        "id": "8fceebcc-a93b-4692-81ea-331b2e59d43d",
        "name": "Protection",
        "role": "Tank",
        "shortName": "Prot",
        "spellIds": [
          "1012c0a1-b2b4-4176-94a9-d47d198e21c3",
          "42156402-c5f5-4b2e-91e4-531189825a47",
          "77116d42-1a38-41f5-a655-e8757ef0428e",
          "b2e25425-b989-437e-aca8-e62156f9ba65",
          "ecbd7b52-095c-4235-ba4f-cac68ed81f07"
        ],
        "talentIds": [
          "08934f1c-beda-433f-aa24-8c7056f190de",
          "1ad4605f-1098-4c6c-96ee-dad6e503dbfa",
          "29e5b934-702a-49b8-896a-3bae79e4570c",
          "9af98e94-57d6-442f-b31d-8481dc960391",
          "aaac0711-6e84-472b-a1c1-652c8f833c60",
          "bb8c6b1f-9882-4de1-ba3a-a336b3e2f83e",
          "f2af9c45-0654-4dea-bbff-1f1272279129",
          "fbd06f55-71cc-422f-b03e-8b1a2bb50980"
        ]
      },
      "a022f6ed-2b4e-4ddf-a7e9-7fb746f5adc2": {
        "classId": "843ce836-b215-488f-b73b-d08e3904ddca",
        "icon_name": "spell_frost_frostbolt02",
        "id": "a022f6ed-2b4e-4ddf-a7e9-7fb746f5adc2",
        "name": "Frost",
        "role": "Ranged DPS",
        "shortName": "Frost",
        "spellIds": [
          "0c684f02-ff97-4423-b2b4-e49f80ce337e"
        ],
        "talentIds": [
          "2ac4e358-e222-4c2e-81ea-67d0a1878997"
        ]
      },
      "ab48ab5c-dfb9-4ce9-9557-8d0ce5129df2": {
        "classId": "843ce836-b215-488f-b73b-d08e3904ddca",
        "icon_name": "spell_holy_magicalsentry",
        "id": "ab48ab5c-dfb9-4ce9-9557-8d0ce5129df2",
        "name": "Arcane",
        "role": "Ranged DPS",
        "shortName": "Arcane",
        "spellIds": [
          "101a477e-6c15-4737-a6f7-6c1a160af6a3",
          "77acb516-6b8f-41fb-986c-a27fec78a268",
          "a22311c6-51f4-4e91-91b7-84714dad3732",
          "d1cb7755-045b-42d3-b61d-1e77bf93e2ab"
        ],
        "talentIds": [
          "1ef6a0a8-330f-4ae0-b6ac-b16ff8175985",
          "6923f864-ad8f-4925-9a84-070df62696f7",
          "85054271-9346-4fb8-befb-d630584f60d8",
          "e18bbe7e-148c-4b9a-b04b-4e55e3bde3af"
        ]
      },
      "af2ca3dc-34c9-4632-98d2-6ea12a2a72f9": {
        "classId": "d599cd61-11ae-4a4d-a856-60d1c7f4572d",
        "icon_name": "spell_shaman_improvedstormstrike",
        "id": "af2ca3dc-34c9-4632-98d2-6ea12a2a72f9",
        "name": "Enhancement",
        "role": "Melee DPS",
        "shortName": "Enh",
        "spellIds": [
          "735fc594-57f3-413c-8000-8ea8aeb3a20e",
          "ab2775c2-9bde-4a82-bece-734c34331605"
        ],
        "talentIds": [
          "0443895f-c5d7-4ac4-ae1a-0fc356481c36",
          "23575f08-d1ae-4f0c-89a1-35de86cd38d3",
          "24301623-78be-4acd-90a5-52ebfa22b21e",
          "387731b9-c4fd-4f4b-81c5-a5fe97b6ca8e",
          "c3460d10-12fa-4f28-a400-8aa45a40c075"
        ]
      },
      "b72fb4f9-413a-4222-8569-b3cb8e5e67f2": {
        "classId": "532f16f1-1e8b-4aba-af5d-17b292fc05fd",
        "icon_name": "spell_deathknight_frostpresence",
        "id": "b72fb4f9-413a-4222-8569-b3cb8e5e67f2",
        "name": "Frost",
        "role": "Melee DPS",
        "shortName": "Frost",
        "spellIds": [
          "218ec9c8-14a5-4e52-821b-30e701619ebd",
          "de825485-2096-4c97-ac2f-b6d52a890970"
        ],
        "talentIds": [
          "29c3a6b1-c239-4c62-8cbc-17851246f2ca",
          "b20ce071-7803-4516-987a-fa837638ecc5"
        ]
      },
      "bcaf8201-dac9-48b9-b329-f2d73d7e8a8b": {
        "classId": "1d680db4-2a3f-4805-800d-00ea34d98880",
        "icon_name": "spell_shadow_metamorphosis",
        "id": "bcaf8201-dac9-48b9-b329-f2d73d7e8a8b",
        "name": "Demonology",
        "role": "Ranged DPS",
        "shortName": "Demo",
        "spellIds": [],
        "talentIds": []
      },
      "be905ae2-ec32-49bf-bc82-ef1cbf83ce9f": {
        "classId": "3667f06e-ab4c-4b9d-8fd0-c6640ad86486",
        "icon_name": "ability_racial_bearform",
        "id": "be905ae2-ec32-49bf-bc82-ef1cbf83ce9f",
        "name": "Guardian",
        "role": "Tank",
        "shortName": "Guard",
        "spellIds": [
          "17336c8c-6723-44ee-a7e0-07d77f97f207",
          "1fd3f0ec-fcfa-47d2-931d-1046f41aacd8",
          "7b184ca9-113a-44d8-8be1-a658db10155e",
          "b781e71d-7f4c-4ca1-981b-65a56154555d"
        ],
        "talentIds": [
          "0ed2857e-162c-4655-a874-0e1bd27d580c",
          "32afdfd0-fcbc-42b7-aa73-d5a0a182c250",
          "54a7aa89-b5e0-47c4-923f-553cce4af783",
          "7d92941f-be8d-4993-a845-2787dbd3e8e3"
        ]
      },
      "c719a5bb-cbad-4e7b-841e-bbc7f28f6865": {
        "classId": "1d680db4-2a3f-4805-800d-00ea34d98880",
        "icon_name": "spell_shadow_rainoffire",
        "id": "c719a5bb-cbad-4e7b-841e-bbc7f28f6865",
        "name": "Destruction",
        "role": "Ranged DPS",
        "shortName": "Destro",
        "spellIds": [],
        "talentIds": []
      },
      "c95c2375-57fa-4ae8-9d55-c2e939b82247": {
        "classId": "122a0a6d-d523-4cc2-a743-f3d42d3e7f02",
        "icon_name": "ability_demonhunter_spectank",
        "id": "c95c2375-57fa-4ae8-9d55-c2e939b82247",
        "name": "Vengeance",
        "role": "Tank",
        "shortName": "Veng",
        "spellIds": [
          "e4351f7c-0801-42d7-ba5c-22b53dbe7b63"
        ],
        "talentIds": [
          "56c44c32-56d3-4b05-b190-d081d7d92887",
          "942880fa-5ba3-4a7e-9fc7-66f0c1eaa773"
        ]
      },
      "cbfc9a1d-a504-4c56-8887-681e57a87211": {
        "classId": "fabd40be-24a8-4b80-8445-416b6e77e15f",
        "icon_name": "classicon_evoker_devastation",
        "id": "cbfc9a1d-a504-4c56-8887-681e57a87211",
        "name": "Devastation",
        "role": "Ranged DPS",
        "shortName": "Deva",
        "spellIds": [
          "2bf63906-ceab-45aa-8244-82b8b2f40fa4",
          "e2008809-fa49-45f5-88cc-69d69f09d3f7",
          "e808a728-ffb6-4144-b3de-3814260fdb3e",
          "f7710243-7665-432d-af2a-565c91498eb1"
        ],
        "talentIds": [
          "a7e35d51-0b24-459f-a910-3c171a1f1c2c",
          "cac23db6-fdaa-4d74-874f-ef7e48f654a3",
          "d12ab590-e070-4499-a46b-8f8d9f6d87f9",
          "db125588-e68c-4063-9294-3b24618a0e06"
        ]
      },
      "d122a0b5-d857-4bc5-a456-c7250f8f6690": {
        "classId": "f3899285-de29-4692-a640-98b5d03579ee",
        "icon_name": "spell_holy_guardianspirit",
        "id": "d122a0b5-d857-4bc5-a456-c7250f8f6690",
        "name": "Holy",
        "role": "Healer",
        "shortName": "Holy",
        "spellIds": [
          "27d704f8-5e10-4186-93ad-04fb65934e68",
          "417ea2a4-0137-408f-b136-de37029b6f02",
          "565c4ff6-e96a-476e-a391-782820dfde80",
          "7b7df88f-fcdd-486d-9100-d715c05465b3",
          "cea5efd9-784b-4905-aa57-877f6c079224",
          "dd8fb0eb-9eb6-409b-8273-3c385272cdd1",
          "df390fec-d40e-440c-95d6-b1674dd93db2"
        ],
        "talentIds": [
          "12c8bd27-583f-4962-a64e-1e679884f2ba",
          "2748443f-7a4b-4590-8247-f2a1e8012497",
          "2f0bd1e5-b6a6-4f22-9eb5-b7cc2764e42d",
          "3a9532a9-1628-48e5-bfa5-6c86f01e984b",
          "47a49203-fab9-45e1-83f9-8e8d05610884",
          "5bfef2d9-ac8d-4ab7-8130-c189613aecf5",
          "60239fe4-730f-4e48-b76a-b6dfcf2e849c",
          "ac6a2554-4ca1-4af8-9470-a7c35bc006b4"
        ]
      },
      "da2dc773-9412-4b11-ab2b-7d06e200b9d3": {
        "classId": "9223f4e8-8669-451e-815a-d53a19416c5a",
        "icon_name": "spell_monk_mistweaver_spec",
        "id": "da2dc773-9412-4b11-ab2b-7d06e200b9d3",
        "name": "Mistweaver",
        "role": "Healer",
        "shortName": "MW",
        "spellIds": [
          "251895f0-3d43-4ec5-92c7-f2063b0b9664",
          "326c88a3-2bb1-45a0-994d-c3b781466600",
          "329084ee-be01-401d-973a-ac2b7d2e2045",
          "56a8ac4a-31a5-48d6-837b-3bd7af64691f",
          "6cd93bbd-5d10-4f8e-9df8-1b5a484f39c9",
          "8f757123-5b98-46e4-970f-99c5107dce72"
        ],
        "talentIds": [
          "43e9d1e3-6222-49a9-885d-e5ef18895d51",
          "57257465-dc2e-4329-8aa5-654ab01cafdd",
          "697468b8-0ac6-4eac-a025-e2c8add98f9a",
          "85688f8c-a893-4da2-8ddd-95440e3ca0f5",
          "a1190285-e0a2-484c-9471-d4244f4709b9",
          "c4fb1719-67a6-40f5-89ed-d11eb98a97f8",
          "f4826595-8556-48d2-bd8d-1d65d16cfb10"
        ]
      },
      "e1af3b62-ddf5-4369-a528-dab8ab94d366": {
        "classId": "d056557a-1414-4958-b859-11656dfc0528",
        "icon_name": "spell_holy_holybolt",
        "id": "e1af3b62-ddf5-4369-a528-dab8ab94d366",
        "name": "Holy",
        "role": "Healer",
        "shortName": "Holy",
        "spellIds": [
          "2d5f4ca4-50ce-4b63-82f6-608e243750b3",
          "3c83d513-533d-492d-9bef-0623db138049",
          "5ee6a82a-ebcc-45d6-8e3d-9668f9b1e059",
          "5fddf206-784d-4f84-9237-7bb80cc15ab7",
          "713c29b6-5bdb-4796-b376-3bde75ae6b4b",
          "a75f53b3-76f6-47bd-98f2-94213cd65a4f",
          "a951b8ac-cb01-4f01-a0f8-38df076bf301",
          "c90b5bf9-7ffc-47d8-b376-ba72186e25b3",
          "d1e7f489-2653-4e4c-a515-30c7a5276797"
        ],
        "talentIds": [
          "0b20bfaa-6d9b-4d48-82ab-91e8bfa0a0ae",
          "13c1b475-07ae-47ae-8c40-f8f6e8c65b80",
          "3a8b4082-7e3f-4769-9aef-0afb0c6218c0",
          "3bb079c8-2c07-4ae3-916f-b613cd94dce0",
          "4c69476f-cbfc-4ab4-90c4-77d7994672b3",
          "99080003-2bd8-4434-8cf0-06dfc5c689b6",
          "a107c2ad-9fb6-494b-bb2d-9e3eb65ae4ea",
          "b6b61f4c-5577-457a-bf54-3547661a4dce",
          "d635d8b8-1c98-41c9-8ee2-67f9e427b23c",
          "fbed7388-e41a-4a31-9c97-6f4aa5fbec72"
        ]
      },
      "e6b1de69-ce2c-467c-ae7a-e1613ba23fb9": {
        "classId": "fabd40be-24a8-4b80-8445-416b6e77e15f",
        "icon_name": "classicon_evoker_augmentation",
        "id": "e6b1de69-ce2c-467c-ae7a-e1613ba23fb9",
        "name": "Augmentation",
        "role": "Ranged DPS",
        "shortName": "Aug",
        "spellIds": [
          "15de70ab-5f4d-4d2a-81fc-bcbd6f25943f",
          "71ed0b6b-d352-4366-aa9a-526fe005f36a",
          "82948bc5-557a-4406-9c79-58b549ad61c0",
          "86c5ede8-4b3a-453e-a30d-7217ac216ddc"
        ],
        "talentIds": [
          "3ff77a62-6e49-4f1b-a57e-633531b12d51",
          "62c3849f-7ce6-49b0-878c-3ffd80cc0cfa",
          "7010c6b1-7294-42c2-83f9-41a824dd50b3",
          "a53276ad-cac3-4b9c-8d1f-a0799aa72517"
        ]
      },
      "e92b34bc-aa34-4579-a543-2ece2545d981": {
        "classId": "0a450e25-065c-4c3c-a881-cea74cf08462",
        "icon_name": "ability_warrior_savageblow",
        "id": "e92b34bc-aa34-4579-a543-2ece2545d981",
        "name": "Arms",
        "role": "Melee DPS",
        "shortName": "Arms",
        "spellIds": [
          "fedce7ea-cda3-412e-84ba-1e9a5f98a996"
        ],
        "talentIds": []
      },
      "f7e76d65-219d-47f1-be05-d7464de52a14": {
        "classId": "1d680db4-2a3f-4805-800d-00ea34d98880",
        "icon_name": "spell_shadow_deathcoil",
        "id": "f7e76d65-219d-47f1-be05-d7464de52a14",
        "name": "Affliction",
        "role": "Ranged DPS",
        "shortName": "Affli",
        "spellIds": [],
        "talentIds": []
      },
      "f950baa2-0deb-4250-a225-5232b1e74c2c": {
        "classId": "5b6efded-e5dd-4429-adfd-2c6d3893e678",
        "icon_name": "ability_stealth",
        "id": "f950baa2-0deb-4250-a225-5232b1e74c2c",
        "name": "Subtlety",
        "role": "Melee DPS",
        "shortName": "Sub",
        "spellIds": [],
        "talentIds": []
      },
      "fc46ed9d-3914-469f-a71f-6e4495efcf27": {
        "classId": "5b6efded-e5dd-4429-adfd-2c6d3893e678",
        "icon_name": "ability_rogue_deadlybrew",
        "id": "fc46ed9d-3914-469f-a71f-6e4495efcf27",
        "name": "Assassination",
        "role": "Melee DPS",
        "shortName": "Assa",
        "spellIds": [],
        "talentIds": []
      }
    },
    "spellsById": {
      "0068e949-b039-4f31-b7de-b63aff00e4e5": {
        "affectedByModifierIds": [],
        "cooldown": 180,
        "game_id": 34433,
        "icon_name": "spell_shadow_shadowfiend",
        "id": "0068e949-b039-4f31-b7de-b63aff00e4e5",
        "name": "Shadowfiend",
        "shortName": "Fiend"
      },
      "01c21fba-6d03-4334-a79a-d34aa45baec4": {
        "affectedByModifierIds": [],
        "cooldown": 180,
        "game_id": 29166,
        "icon_name": "spell_nature_lightning",
        "id": "01c21fba-6d03-4334-a79a-d34aa45baec4",
        "name": "Innervate",
        "shortName": "Inn",
        "talentId": "69827ab3-42ef-4913-a09e-b923d37bf960"
      },
      "030b5e2c-d6ff-4998-84d5-9f90184dfab2": {
        "affectedByModifierIds": [],
        "cooldown": 180,
        "game_id": 108285,
        "icon_name": "ability_shaman_multitotemactivation",
        "id": "030b5e2c-d6ff-4998-84d5-9f90184dfab2",
        "link_suffix": "",
        "name": "Totemic Recall",
        "shortName": "Recall",
        "talentId": "5f356c9e-aa59-4134-ba94-ba4e0eb365d3"
      },
      "0be1c70c-7f60-4a80-b494-6c6c02ce1256": {
        "affectedByModifierIds": [],
        "cooldown": 120,
        "game_id": 374968,
        "icon_name": "ability_evoker_timespiral",
        "id": "0be1c70c-7f60-4a80-b494-6c6c02ce1256",
        "name": "Time Spiral",
        "shortName": "Spiral",
        "talentId": "e0ed8a5e-e384-490e-bae8-b0bbe94ccf3f"
      },
      "0c684f02-ff97-4423-b2b4-e49f80ce337e": {
        "affectedByModifierIds": [],
        "cooldown": 180,
        "game_id": 414660,
        "icon_name": "ability_racial_magicalresistance",
        "id": "0c684f02-ff97-4423-b2b4-e49f80ce337e",
        "name": "Mass Barrier",
        "shortName": "Barrier",
        "talentId": "2ac4e358-e222-4c2e-81ea-67d0a1878997"
      },
      "0ede88ec-4877-4d9e-aee2-6d9d71055425": {
        "affectedByModifierIds": [],
        "cooldown": 120,
        "game_id": 32375,
        "icon_name": "spell_arcane_massdispel",
        "id": "0ede88ec-4877-4d9e-aee2-6d9d71055425",
        "name": "Mass Dispel",
        "shortName": "Mass",
        "talentId": "55d279c4-3b32-48bc-afe6-fba03504e6f8"
      },
      "1012c0a1-b2b4-4176-94a9-d47d198e21c3": {
        "affectedByModifierIds": [],
        "cooldown": 300,
        "game_id": 1022,
        "icon_name": "spell_holy_sealofprotection",
        "id": "1012c0a1-b2b4-4176-94a9-d47d198e21c3",
        "name": "Blessing of Protection",
        "shortName": "BoP",
        "talentId": "bb8c6b1f-9882-4de1-ba3a-a336b3e2f83e"
      },
      "101a477e-6c15-4737-a6f7-6c1a160af6a3": {
        "affectedByModifierIds": [],
        "cooldown": 180,
        "game_id": 414660,
        "icon_name": "ability_racial_magicalresistance",
        "id": "101a477e-6c15-4737-a6f7-6c1a160af6a3",
        "name": "Mass Barrier",
        "shortName": "Barrier",
        "talentId": "1ef6a0a8-330f-4ae0-b6ac-b16ff8175985"
      },
      "1260da03-81c4-41cc-a693-addcd98c067f": {
        "affectedByModifierIds": [],
        "cooldown": 180,
        "game_id": 97462,
        "icon_name": "ability_warrior_rallyingcry",
        "id": "1260da03-81c4-41cc-a693-addcd98c067f",
        "name": "Rallying Cry",
        "shortName": "RC"
      },
      "141b3ae0-2175-4c92-b384-f7503a15fc2a": {
        "affectedByModifierIds": [],
        "cooldown": 180,
        "game_id": 370960,
        "icon_name": "ability_evoker_green_01",
        "id": "141b3ae0-2175-4c92-b384-f7503a15fc2a",
        "name": "Emerald Communion",
        "shortName": "Com",
        "talentId": "3725d5f9-9f0d-4247-b601-593641f2b400"
      },
      "15de70ab-5f4d-4d2a-81fc-bcbd6f25943f": {
        "affectedByModifierIds": [],
        "cooldown": 120,
        "game_id": 374227,
        "icon_name": "ability_evoker_hoverblack",
        "id": "15de70ab-5f4d-4d2a-81fc-bcbd6f25943f",
        "name": "Zephyr",
        "shortName": "Zeph",
        "talentId": "7010c6b1-7294-42c2-83f9-41a824dd50b3"
      },
      "17336c8c-6723-44ee-a7e0-07d77f97f207": {
        "affectedByModifierIds": [],
        "cooldown": 60,
        "game_id": 102793,
        "icon_name": "spell_druid_ursolsvortex",
        "id": "17336c8c-6723-44ee-a7e0-07d77f97f207",
        "link_suffix": "",
        "name": "Ursol's Vortex",
        "shortName": "Vor",
        "talentId": "32afdfd0-fcbc-42b7-aa73-d5a0a182c250"
      },
      "1a034bc0-02b1-4222-bd49-abdbd49de23c": {
        "affectedByModifierIds": [],
        "cooldown": 30,
        "game_id": 116841,
        "icon_name": "ability_monk_tigerslust",
        "id": "1a034bc0-02b1-4222-bd49-abdbd49de23c",
        "name": "Tiger's Lust",
        "shortName": "Lust",
        "talentId": "7ed586dd-19c5-46e7-be0e-0bd9b4564584"
      },
      "1d81f543-080f-4afa-8232-35b3c41450a7": {
        "affectedByModifierIds": [],
        "cooldown": 120,
        "game_id": 192077,
        "icon_name": "ability_shaman_windwalktotem",
        "id": "1d81f543-080f-4afa-8232-35b3c41450a7",
        "name": "Wind Rush Totem",
        "shortName": "WRT",
        "talentId": "b42a618a-6020-4766-8fbb-8427b0589f3e"
      },
      "1ee4bd80-9de9-49cd-94c4-93e1b64de6d4": {
        "affectedByModifierIds": [],
        "cooldown": 180,
        "game_id": 62618,
        "icon_name": "spell_holy_powerwordbarrier",
        "id": "1ee4bd80-9de9-49cd-94c4-93e1b64de6d4",
        "name": "Power Word: Barrier",
        "shortName": "PW:B"
      },
      "1fd3f0ec-fcfa-47d2-931d-1046f41aacd8": {
        "affectedByModifierIds": [],
        "cooldown": 120,
        "game_id": 106898,
        "icon_name": "spell_druid_stampedingroar_cat",
        "id": "1fd3f0ec-fcfa-47d2-931d-1046f41aacd8",
        "name": "Stampeding Roar",
        "shortName": "Roar"
      },
      "218ec9c8-14a5-4e52-821b-30e701619ebd": {
        "affectedByModifierIds": [],
        "cooldown": 120,
        "game_id": 51052,
        "icon_name": "spell_deathknight_antimagiczone",
        "id": "218ec9c8-14a5-4e52-821b-30e701619ebd",
        "name": "Anti-Magic Zone",
        "shortName": "AMZ"
      },
      "22d28f2e-4543-4754-a890-a76d3a49a548": {
        "affectedByModifierIds": [],
        "cooldown": 60,
        "game_id": 119381,
        "icon_name": "ability_monk_legsweep",
        "id": "22d28f2e-4543-4754-a890-a76d3a49a548",
        "link_suffix": "",
        "name": "Leg Sweep",
        "shortName": "Sweep"
      },
      "24b79c04-7217-492e-aca6-4500fa80124c": {
        "affectedByModifierIds": [],
        "cooldown": 120,
        "game_id": 6940,
        "icon_name": "spell_holy_sealofsacrifice",
        "id": "24b79c04-7217-492e-aca6-4500fa80124c",
        "name": "Blessing of Sacrifice",
        "shortName": "Sac",
        "talentId": "e30f64db-ddce-4fee-8770-e0db405b5e02"
      },
      "251895f0-3d43-4ec5-92c7-f2063b0b9664": {
        "affectedByModifierIds": [],
        "cooldown": 120,
        "game_id": 322118,
        "icon_name": "ability_monk_dragonkick",
        "id": "251895f0-3d43-4ec5-92c7-f2063b0b9664",
        "link_suffix": "",
        "name": "Invoke Yu'lon, the Jade Serpent",
        "shortName": "Yulon",
        "talentId": "85688f8c-a893-4da2-8ddd-95440e3ca0f5"
      },
      "25555cd2-b57a-42c1-80ff-98d9025d59a1": {
        "affectedByModifierIds": [],
        "cooldown": 90,
        "game_id": 73325,
        "icon_name": "priest_spell_leapoffaith_a",
        "id": "25555cd2-b57a-42c1-80ff-98d9025d59a1",
        "name": "Leap of Faith",
        "shortName": "Leap",
        "talentId": "e4110ee3-e5be-4e09-aa25-e580a7b09d97"
      },
      "279e6146-898b-482f-9b99-a74845c191ac": {
        "affectedByModifierIds": [],
        "cooldown": 120,
        "game_id": 51052,
        "icon_name": "spell_deathknight_antimagiczone",
        "id": "279e6146-898b-482f-9b99-a74845c191ac",
        "name": "Anti-Magic Zone",
        "shortName": "AMZ"
      },
      "27d704f8-5e10-4186-93ad-04fb65934e68": {
        "affectedByModifierIds": [],
        "cooldown": 180,
        "game_id": 47788,
        "icon_name": "spell_holy_guardianspirit",
        "id": "27d704f8-5e10-4186-93ad-04fb65934e68",
        "name": "Guardian Spirit",
        "shortName": "GS",
        "talentId": "2f0bd1e5-b6a6-4f22-9eb5-b7cc2764e42d"
      },
      "2ab4cecf-5bbc-4af0-b1e6-136266ac36eb": {
        "affectedByModifierIds": [],
        "cooldown": 180,
        "game_id": 29166,
        "icon_name": "spell_nature_lightning",
        "id": "2ab4cecf-5bbc-4af0-b1e6-136266ac36eb",
        "name": "Innervate",
        "shortName": "Inn",
        "talentId": "6467fbd3-c882-4737-a3b0-eb61173588d0"
      },
      "2bf63906-ceab-45aa-8244-82b8b2f40fa4": {
        "affectedByModifierIds": [],
        "cooldown": 120,
        "game_id": 406732,
        "icon_name": "ability_evoker_stretchtime",
        "id": "2bf63906-ceab-45aa-8244-82b8b2f40fa4",
        "name": "Spatial Paradox",
        "shortName": "Para",
        "talentId": "db125588-e68c-4063-9294-3b24618a0e06"
      },
      "2d5f4ca4-50ce-4b63-82f6-608e243750b3": {
        "affectedByModifierIds": [],
        "cooldown": 90,
        "game_id": 200652,
        "icon_name": "inv_mace_2h_artifactsilverhand_d_01",
        "id": "2d5f4ca4-50ce-4b63-82f6-608e243750b3",
        "name": "Tyr's Deliverance",
        "shortName": "Tyr",
        "talentId": "a107c2ad-9fb6-494b-bb2d-9e3eb65ae4ea"
      },
      "326c88a3-2bb1-45a0-994d-c3b781466600": {
        "affectedByModifierIds": [],
        "cooldown": 120,
        "game_id": 325197,
        "icon_name": "inv_pet_cranegod",
        "id": "326c88a3-2bb1-45a0-994d-c3b781466600",
        "name": "Invoke Chi-Ji, the Red Crane",
        "shortName": "Chi",
        "talentId": "43e9d1e3-6222-49a9-885d-e5ef18895d51"
      },
      "329084ee-be01-401d-973a-ac2b7d2e2045": {
        "affectedByModifierIds": [],
        "cooldown": 120,
        "game_id": 116849,
        "icon_name": "ability_monk_chicocoon",
        "id": "329084ee-be01-401d-973a-ac2b7d2e2045",
        "name": "Life Cocoon",
        "shortName": "Coco"
      },
      "34515fa9-70f9-4a82-ba89-262b8d67c19d": {
        "affectedByModifierIds": [],
        "cooldown": 90,
        "game_id": 73325,
        "icon_name": "priest_spell_leapoffaith_a",
        "id": "34515fa9-70f9-4a82-ba89-262b8d67c19d",
        "name": "Leap of Faith",
        "shortName": "Leap",
        "talentId": "dbd77078-c13d-4698-9837-255c458b30dd"
      },
      "354aaa0a-f46d-4cea-9226-7a9be0c05723": {
        "affectedByModifierIds": [],
        "cooldown": 180,
        "game_id": 186265,
        "icon_name": "ability_hunter_pet_turtle",
        "id": "354aaa0a-f46d-4cea-9226-7a9be0c05723",
        "name": "Aspect of the Turtle",
        "shortName": "Turtle"
      },
      "3599c0ce-cfa3-4434-b1c8-7e2987ac9de9": {
        "affectedByModifierIds": [],
        "cooldown": 120,
        "game_id": 10060,
        "icon_name": "spell_holy_powerinfusion",
        "id": "3599c0ce-cfa3-4434-b1c8-7e2987ac9de9",
        "name": "Power Infusion",
        "shortName": "PI",
        "talentId": "785b2684-c8e9-49d8-bc0d-345e37f22848"
      },
      "38fd80ac-1990-4a29-845f-622648797f07": {
        "affectedByModifierIds": [],
        "cooldown": 300,
        "game_id": 1022,
        "icon_name": "spell_holy_sealofprotection",
        "id": "38fd80ac-1990-4a29-845f-622648797f07",
        "name": "Blessing of Protection",
        "shortName": "BoP",
        "talentId": "bf99cae6-ff7b-4020-83c5-01405fe3869f"
      },
      "3c83d513-533d-492d-9bef-0623db138049": {
        "affectedByModifierIds": [],
        "cooldown": 120,
        "game_id": 31884,
        "icon_name": "spell_holy_avenginewrath",
        "id": "3c83d513-533d-492d-9bef-0623db138049",
        "link_suffix": "",
        "name": "Avenging Wrath",
        "shortName": "Wings",
        "talentId": "d635d8b8-1c98-41c9-8ee2-67f9e427b23c"
      },
      "41702c8c-996b-4e69-aabe-fb6a9af6b7bf": {
        "affectedByModifierIds": [],
        "cooldown": 120,
        "game_id": 383269,
        "icon_name": "ability_maldraxxus_deathknight",
        "id": "41702c8c-996b-4e69-aabe-fb6a9af6b7bf",
        "link_suffix": "",
        "name": "Abomination Limb",
        "shortName": "Abom",
        "talentId": "ddf5e9b4-563c-489c-9e2c-969ef9137d90"
      },
      "417ea2a4-0137-408f-b136-de37029b6f02": {
        "affectedByModifierIds": [],
        "cooldown": 90,
        "game_id": 73325,
        "icon_name": "priest_spell_leapoffaith_a",
        "id": "417ea2a4-0137-408f-b136-de37029b6f02",
        "name": "Leap of Faith",
        "shortName": "Leap",
        "talentId": "2748443f-7a4b-4590-8247-f2a1e8012497"
      },
      "42156402-c5f5-4b2e-91e4-531189825a47": {
        "affectedByModifierIds": [],
        "cooldown": 300,
        "game_id": 204018,
        "icon_name": "spell_holy_blessingofprotection",
        "id": "42156402-c5f5-4b2e-91e4-531189825a47",
        "name": "Blessing of Spellwarding",
        "shortName": "Ward"
      },
      "42339fbf-de98-4081-a66b-68958bcb3246": {
        "affectedByModifierIds": [],
        "cooldown": 180,
        "game_id": 186265,
        "icon_name": "ability_hunter_pet_turtle",
        "id": "42339fbf-de98-4081-a66b-68958bcb3246",
        "name": "Aspect of the Turtle",
        "shortName": "Turtle"
      },
      "462666f3-b5f0-4dd0-806c-58d95be98dda": {
        "affectedByModifierIds": [],
        "cooldown": 120,
        "game_id": 391528,
        "icon_name": "ability_ardenweald_druid",
        "id": "462666f3-b5f0-4dd0-806c-58d95be98dda",
        "name": "Convoke the Spirits",
        "shortName": "Con",
        "talentId": "a850f1e4-51d9-4019-93a6-1d2fbc9b07f3"
      },
      "47dca887-ece0-458e-a98d-6ac8dc58a775": {
        "affectedByModifierIds": [],
        "cooldown": 60,
        "game_id": 119381,
        "icon_name": "ability_monk_legsweep",
        "id": "47dca887-ece0-458e-a98d-6ac8dc58a775",
        "link_suffix": "",
        "name": "Leg Sweep",
        "shortName": "Sweep"
      },
      "4bae75e8-50ef-492c-96a2-c3287a54768d": {
        "affectedByModifierIds": [],
        "cooldown": 180,
        "game_id": 414660,
        "icon_name": "ability_racial_magicalresistance",
        "id": "4bae75e8-50ef-492c-96a2-c3287a54768d",
        "name": "Mass Barrier",
        "shortName": "Barrier",
        "talentId": "07cab4a9-2332-45e0-a119-728f2fa001ad"
      },
      "4e56230b-e5a3-4799-8429-a08086373c1e": {
        "affectedByModifierIds": [],
        "cooldown": 45,
        "game_id": 53271,
        "icon_name": "ability_hunter_masterscall",
        "id": "4e56230b-e5a3-4799-8429-a08086373c1e",
        "modifierId": "068f6ed7-c9ef-413e-a447-f7d779ad9aa1",
        "name": "Master's Call",
        "shortName": "Call"
      },
      "4f0bef06-d8f2-4edf-aa0d-03b071ad0ad9": {
        "affectedByModifierIds": [],
        "cooldown": 120,
        "game_id": 374227,
        "icon_name": "ability_evoker_hoverblack",
        "id": "4f0bef06-d8f2-4edf-aa0d-03b071ad0ad9",
        "name": "Zephyr",
        "shortName": "Zeph",
        "talentId": "d3313379-f52e-4693-8d02-2ff8414771e2"
      },
      "5070b303-2953-4a55-bb51-a0bd8344fe09": {
        "affectedByModifierIds": [],
        "cooldown": 30,
        "game_id": 116841,
        "icon_name": "ability_monk_tigerslust",
        "id": "5070b303-2953-4a55-bb51-a0bd8344fe09",
        "name": "Tiger's Lust",
        "shortName": "Lust"
      },
      "5591738a-9f04-4847-9437-dbfdbc6fedf3": {
        "affectedByModifierIds": [],
        "cooldown": 300,
        "game_id": 207399,
        "icon_name": "spell_nature_reincarnation",
        "id": "5591738a-9f04-4847-9437-dbfdbc6fedf3",
        "name": "Ancestral Protection Totem",
        "shortName": "APT",
        "talentId": "dcc7c4b8-754b-48bf-b32b-f7962a361640"
      },
      "565c4ff6-e96a-476e-a391-782820dfde80": {
        "affectedByModifierIds": [],
        "cooldown": 120,
        "game_id": 10060,
        "icon_name": "spell_holy_powerinfusion",
        "id": "565c4ff6-e96a-476e-a391-782820dfde80",
        "name": "Power Infusion",
        "shortName": "PI",
        "talentId": "3a9532a9-1628-48e5-bfa5-6c86f01e984b"
      },
      "56a8ac4a-31a5-48d6-837b-3bd7af64691f": {
        "affectedByModifierIds": [],
        "cooldown": 30,
        "game_id": 116841,
        "icon_name": "ability_monk_tigerslust",
        "id": "56a8ac4a-31a5-48d6-837b-3bd7af64691f",
        "name": "Tiger's Lust",
        "shortName": "Lust",
        "talentId": "a1190285-e0a2-484c-9471-d4244f4709b9"
      },
      "57aa024a-6536-49c2-aa2a-12c61ce500de": {
        "affectedByModifierIds": [],
        "cooldown": 45,
        "game_id": 53271,
        "icon_name": "ability_hunter_masterscall",
        "id": "57aa024a-6536-49c2-aa2a-12c61ce500de",
        "modifierId": "068f6ed7-c9ef-413e-a447-f7d779ad9aa1",
        "name": "Master's Call",
        "shortName": "Call"
      },
      "5a29401a-fc11-4cfd-8ea2-3ffd2bc73a05": {
        "affectedByModifierIds": [],
        "cooldown": 180,
        "game_id": 97462,
        "icon_name": "ability_warrior_rallyingcry",
        "id": "5a29401a-fc11-4cfd-8ea2-3ffd2bc73a05",
        "name": "Rallying Cry",
        "shortName": "RC"
      },
      "5ee6a82a-ebcc-45d6-8e3d-9668f9b1e059": {
        "affectedByModifierIds": [],
        "cooldown": 60,
        "game_id": 375576,
        "icon_name": "ability_bastion_paladin",
        "id": "5ee6a82a-ebcc-45d6-8e3d-9668f9b1e059",
        "name": "Divine Toll",
        "shortName": "Toll",
        "talentId": "0b20bfaa-6d9b-4d48-82ab-91e8bfa0a0ae"
      },
      "5fddf206-784d-4f84-9237-7bb80cc15ab7": {
        "affectedByModifierIds": [],
        "cooldown": 45,
        "game_id": 216331,
        "icon_name": "ability_paladin_veneration",
        "id": "5fddf206-784d-4f84-9237-7bb80cc15ab7",
        "name": "Avenging Crusader",
        "shortName": "Crusa",
        "talentId": "13c1b475-07ae-47ae-8c40-f8f6e8c65b80"
      },
      "6cd93bbd-5d10-4f8e-9df8-1b5a484f39c9": {
        "affectedByModifierIds": [],
        "cooldown": 60,
        "game_id": 119381,
        "icon_name": "ability_monk_legsweep",
        "id": "6cd93bbd-5d10-4f8e-9df8-1b5a484f39c9",
        "link_suffix": "",
        "name": "Leg Sweep",
        "shortName": "Sweep"
      },
      "713c29b6-5bdb-4796-b376-3bde75ae6b4b": {
        "affectedByModifierIds": [],
        "cooldown": 120,
        "game_id": 6940,
        "icon_name": "spell_holy_sealofsacrifice",
        "id": "713c29b6-5bdb-4796-b376-3bde75ae6b4b",
        "name": "Blessing of Sacrifice",
        "shortName": "Sac"
      },
      "71ed0b6b-d352-4366-aa9a-526fe005f36a": {
        "affectedByModifierIds": [],
        "cooldown": 120,
        "game_id": 406732,
        "icon_name": "ability_evoker_stretchtime",
        "id": "71ed0b6b-d352-4366-aa9a-526fe005f36a",
        "name": "Spatial Paradox",
        "shortName": "Para",
        "talentId": "a53276ad-cac3-4b9c-8d1f-a0799aa72517"
      },
      "72221d65-18bb-432a-a706-016ea5dd5dc2": {
        "affectedByModifierIds": [],
        "cooldown": 60,
        "game_id": 370665,
        "icon_name": "ability_evoker_flywithme",
        "id": "72221d65-18bb-432a-a706-016ea5dd5dc2",
        "name": "Rescue",
        "shortName": "Resc",
        "talentId": "c788d9cb-8e85-432b-8ec4-763fc36d75bd"
      },
      "735fc594-57f3-413c-8000-8ea8aeb3a20e": {
        "affectedByModifierIds": [],
        "cooldown": 180,
        "game_id": 108285,
        "icon_name": "ability_shaman_multitotemactivation",
        "id": "735fc594-57f3-413c-8000-8ea8aeb3a20e",
        "link_suffix": "",
        "name": "Totemic Recall",
        "shortName": "Recall",
        "talentId": "24301623-78be-4acd-90a5-52ebfa22b21e"
      },
      "743faca6-fb16-43a3-90b7-0362bbb0145f": {
        "affectedByModifierIds": [],
        "cooldown": 120,
        "game_id": 383269,
        "icon_name": "ability_maldraxxus_deathknight",
        "id": "743faca6-fb16-43a3-90b7-0362bbb0145f",
        "link_suffix": "",
        "name": "Abomination Limb",
        "shortName": "Abom",
        "talentId": "d51b0c37-a48f-4c9c-ab59-5056cccd2c97"
      },
      "77116d42-1a38-41f5-a655-e8757ef0428e": {
        "affectedByModifierIds": [],
        "cooldown": 300,
        "game_id": 642,
        "icon_name": "spell_holy_divineshield",
        "id": "77116d42-1a38-41f5-a655-e8757ef0428e",
        "name": "Divine Shield",
        "shortName": "Div"
      },
      "77acb516-6b8f-41fb-986c-a27fec78a268": {
        "affectedByModifierIds": [],
        "cooldown": 300,
        "game_id": 370511,
        "icon_name": "inv_potion_49",
        "id": "77acb516-6b8f-41fb-986c-a27fec78a268",
        "name": "HP Pot",
        "shortName": "Pot",
        "talentId": "85054271-9346-4fb8-befb-d630584f60d8"
      },
      "784675e5-92e8-4ec6-96cb-792cad54ce1a": {
        "affectedByModifierIds": [],
        "cooldown": 60,
        "game_id": 102793,
        "icon_name": "spell_druid_ursolsvortex",
        "id": "784675e5-92e8-4ec6-96cb-792cad54ce1a",
        "link_suffix": "",
        "name": "Ursol's Vortex",
        "shortName": "Vor",
        "talentId": "20669b18-9b9c-4a70-8897-7d2d78dbbd9c"
      },
      "7b184ca9-113a-44d8-8be1-a658db10155e": {
        "affectedByModifierIds": [],
        "cooldown": 180,
        "game_id": 29166,
        "icon_name": "spell_nature_lightning",
        "id": "7b184ca9-113a-44d8-8be1-a658db10155e",
        "name": "Innervate",
        "shortName": "Inn",
        "talentId": "54a7aa89-b5e0-47c4-923f-553cce4af783"
      },
      "7b7df88f-fcdd-486d-9100-d715c05465b3": {
        "affectedByModifierIds": [],
        "cooldown": 120,
        "game_id": 200183,
        "icon_name": "ability_priest_ascension",
        "id": "7b7df88f-fcdd-486d-9100-d715c05465b3",
        "link_suffix": "",
        "name": "Apotheosis",
        "shortName": "Apo",
        "talentId": "47a49203-fab9-45e1-83f9-8e8d05610884"
      },
      "82948bc5-557a-4406-9c79-58b549ad61c0": {
        "affectedByModifierIds": [],
        "cooldown": 120,
        "game_id": 374968,
        "icon_name": "ability_evoker_timespiral",
        "id": "82948bc5-557a-4406-9c79-58b549ad61c0",
        "name": "Time Spiral",
        "shortName": "Spiral",
        "talentId": "3ff77a62-6e49-4f1b-a57e-633531b12d51"
      },
      "86c5ede8-4b3a-453e-a30d-7217ac216ddc": {
        "affectedByModifierIds": [],
        "cooldown": 60,
        "game_id": 370665,
        "icon_name": "ability_evoker_flywithme",
        "id": "86c5ede8-4b3a-453e-a30d-7217ac216ddc",
        "name": "Rescue",
        "shortName": "Resc",
        "talentId": "62c3849f-7ce6-49b0-878c-3ffd80cc0cfa"
      },
      "8f42a93f-7c02-426f-8096-4278e67a6cd7": {
        "affectedByModifierIds": [],
        "cooldown": 90,
        "game_id": 124974,
        "icon_name": "achievement_zone_feralas",
        "id": "8f42a93f-7c02-426f-8096-4278e67a6cd7",
        "name": "Nature's Vigil",
        "shortName": "Vigil",
        "talentId": "23a727ed-218c-4d15-ab63-59c52a812cc3"
      },
      "8f757123-5b98-46e4-970f-99c5107dce72": {
        "affectedByModifierIds": [],
        "cooldown": 180,
        "game_id": 115310,
        "icon_name": "spell_monk_revival",
        "id": "8f757123-5b98-46e4-970f-99c5107dce72",
        "name": "Revival",
        "shortName": "Rev"
      },
      "9a95da74-4439-407b-a567-97c3591eac6d": {
        "affectedByModifierIds": [],
        "cooldown": 240,
        "game_id": 421453,
        "icon_name": "ability_priest_ascendance",
        "id": "9a95da74-4439-407b-a567-97c3591eac6d",
        "name": "Ultimate Penitence",
        "shortName": "Penti",
        "talentId": "abdf54fd-3107-4769-a046-45fc47709cf8"
      },
      "9a9918e7-a2f8-4a5c-a8fa-9e8698ab05dd": {
        "affectedByModifierIds": [],
        "cooldown": 90,
        "game_id": 246287,
        "icon_name": "spell_holy_divineillumination",
        "id": "9a9918e7-a2f8-4a5c-a8fa-9e8698ab05dd",
        "name": "Evang",
        "shortName": "Evang"
      },
      "9ba548ea-fc82-4d61-9b01-3cde12d48716": {
        "affectedByModifierIds": [],
        "cooldown": 300,
        "game_id": 196718,
        "icon_name": "ability_demonhunter_darkness",
        "id": "9ba548ea-fc82-4d61-9b01-3cde12d48716",
        "link_suffix": "",
        "name": "Darkness",
        "shortName": "Dark",
        "talentId": "21fbcd60-b5fa-4da4-ba8f-323f142dcecf"
      },
      "9d80835a-52b9-4d35-a86b-576000445c02": {
        "affectedByModifierIds": [],
        "cooldown": 180,
        "game_id": 98008,
        "icon_name": "spell_shaman_spiritlink",
        "id": "9d80835a-52b9-4d35-a86b-576000445c02",
        "name": "Spirit Link Totem",
        "shortName": "SLT"
      },
      "9e2c4cba-a1df-4717-bf0f-452654fc4903": {
        "affectedByModifierIds": [],
        "cooldown": 90,
        "game_id": 124974,
        "icon_name": "achievement_zone_feralas",
        "id": "9e2c4cba-a1df-4717-bf0f-452654fc4903",
        "name": "Nature's Vigil",
        "shortName": "Vigil",
        "talentId": "92a8ac6f-8d82-497b-a7be-8cb4dfc35493"
      },
      "a22311c6-51f4-4e91-91b7-84714dad3732": {
        "affectedByModifierIds": [],
        "cooldown": 120,
        "game_id": 373905,
        "icon_name": "ability_vehicle_shellshieldgenerator_green",
        "id": "a22311c6-51f4-4e91-91b7-84714dad3732",
        "name": "Personal 2min",
        "shortName": "Pers",
        "talentId": "e18bbe7e-148c-4b9a-b04b-4e55e3bde3af"
      },
      "a72746bd-e803-49a0-9563-7aa61ba66a4e": {
        "affectedByModifierIds": [],
        "cooldown": 45,
        "game_id": 53271,
        "icon_name": "ability_hunter_masterscall",
        "id": "a72746bd-e803-49a0-9563-7aa61ba66a4e",
        "modifierId": "068f6ed7-c9ef-413e-a447-f7d779ad9aa1",
        "name": "Master's Call",
        "shortName": "Call"
      },
      "a75f53b3-76f6-47bd-98f2-94213cd65a4f": {
        "affectedByModifierIds": [],
        "cooldown": 180,
        "game_id": 31821,
        "icon_name": "spell_holy_auramastery",
        "id": "a75f53b3-76f6-47bd-98f2-94213cd65a4f",
        "name": "Aura Mastery",
        "shortName": "AM"
      },
      "a7771e1d-ef0b-476b-9364-8f0b6c8b5a74": {
        "affectedByModifierIds": [],
        "cooldown": 120,
        "game_id": 359816,
        "icon_name": "ability_evoker_dreamflight",
        "id": "a7771e1d-ef0b-476b-9364-8f0b6c8b5a74",
        "name": "Dream Flight",
        "shortName": "Dream",
        "talentId": "69be9306-608e-4446-be1e-cc51ea80988d"
      },
      "a86cff5e-78d8-4e88-8415-e2455108e044": {
        "affectedByModifierIds": [],
        "cooldown": 180,
        "game_id": 108280,
        "icon_name": "ability_shaman_healingtide",
        "id": "a86cff5e-78d8-4e88-8415-e2455108e044",
        "name": "Healing Tide Totem",
        "shortName": "HTT"
      },
      "a951b8ac-cb01-4f01-a0f8-38df076bf301": {
        "affectedByModifierIds": [],
        "cooldown": 300,
        "game_id": 1022,
        "icon_name": "spell_holy_sealofprotection",
        "id": "a951b8ac-cb01-4f01-a0f8-38df076bf301",
        "name": "Blessing of Protection",
        "shortName": "BoP",
        "talentId": "3a8b4082-7e3f-4769-9aef-0afb0c6218c0"
      },
      "a96abc8d-2053-4c85-ad04-86337dbee19e": {
        "affectedByModifierIds": [],
        "cooldown": 60,
        "game_id": 357170,
        "icon_name": "ability_evoker_timedilation",
        "id": "a96abc8d-2053-4c85-ad04-86337dbee19e",
        "name": "Time Dilation",
        "shortName": "Dia"
      },
      "ab2775c2-9bde-4a82-bece-734c34331605": {
        "affectedByModifierIds": [],
        "cooldown": 120,
        "game_id": 192077,
        "icon_name": "ability_shaman_windwalktotem",
        "id": "ab2775c2-9bde-4a82-bece-734c34331605",
        "name": "Wind Rush Totem",
        "shortName": "WRT",
        "talentId": "0443895f-c5d7-4ac4-ae1a-0fc356481c36"
      },
      "ab58a974-2629-4cb5-8248-ebe20b7074ab": {
        "affectedByModifierIds": [],
        "cooldown": 180,
        "game_id": 33206,
        "icon_name": "spell_holy_painsupression",
        "id": "ab58a974-2629-4cb5-8248-ebe20b7074ab",
        "name": "Pain Suppression",
        "shortName": "PS"
      },
      "ad2ca623-1ce1-4436-ad84-68766ef45c35": {
        "affectedByModifierIds": [],
        "cooldown": 180,
        "game_id": 186265,
        "icon_name": "ability_hunter_pet_turtle",
        "id": "ad2ca623-1ce1-4436-ad84-68766ef45c35",
        "name": "Aspect of the Turtle",
        "shortName": "Turtle"
      },
      "addb8673-43ef-48e5-b6d2-d8bb92bb4cdd": {
        "affectedByModifierIds": [],
        "cooldown": 180,
        "game_id": 740,
        "icon_name": "spell_nature_tranquility",
        "id": "addb8673-43ef-48e5-b6d2-d8bb92bb4cdd",
        "name": "Tranquility",
        "shortName": "Tranq"
      },
      "aeba0c47-70cf-4fd4-a69e-785cb2e608b7": {
        "affectedByModifierIds": [],
        "cooldown": 120,
        "game_id": 106898,
        "icon_name": "spell_druid_stampedingroar_cat",
        "id": "aeba0c47-70cf-4fd4-a69e-785cb2e608b7",
        "name": "Stampeding Roar",
        "shortName": "Roar"
      },
      "b2e25425-b989-437e-aca8-e62156f9ba65": {
        "affectedByModifierIds": [],
        "cooldown": 120,
        "game_id": 6940,
        "icon_name": "spell_holy_sealofsacrifice",
        "id": "b2e25425-b989-437e-aca8-e62156f9ba65",
        "name": "Blessing of Sacrifice",
        "shortName": "Sac",
        "talentId": "f2af9c45-0654-4dea-bbff-1f1272279129"
      },
      "b594d808-ad9d-441b-9f63-35d573a6f708": {
        "affectedByModifierIds": [],
        "cooldown": 120,
        "game_id": 106898,
        "icon_name": "spell_druid_stampedingroar_cat",
        "id": "b594d808-ad9d-441b-9f63-35d573a6f708",
        "name": "Stampeding Roar",
        "shortName": "Roar"
      },
      "b781e71d-7f4c-4ca1-981b-65a56154555d": {
        "affectedByModifierIds": [],
        "cooldown": 90,
        "game_id": 124974,
        "icon_name": "achievement_zone_feralas",
        "id": "b781e71d-7f4c-4ca1-981b-65a56154555d",
        "name": "Nature's Vigil",
        "shortName": "Vigil",
        "talentId": "0ed2857e-162c-4655-a874-0e1bd27d580c"
      },
      "b844ccd9-91d9-4c22-90a6-53ecb5fe87be": {
        "affectedByModifierIds": [],
        "cooldown": 180,
        "game_id": 33891,
        "icon_name": "ability_druid_improvedtreeform",
        "id": "b844ccd9-91d9-4c22-90a6-53ecb5fe87be",
        "name": "Incarnation: Tree of Life",
        "shortName": "Tree",
        "talentId": "e7212970-f5d7-4249-80a0-a32a19a13c9a"
      },
      "c5f94a83-5f36-4eee-98c3-188b3d977604": {
        "affectedByModifierIds": [],
        "cooldown": 60,
        "game_id": 102793,
        "icon_name": "spell_druid_ursolsvortex",
        "id": "c5f94a83-5f36-4eee-98c3-188b3d977604",
        "link_suffix": "",
        "name": "Ursol's Vortex",
        "shortName": "Vor",
        "talentId": "19b8b476-3bf6-4ea2-8c39-78421f6a4c42"
      },
      "c90b5bf9-7ffc-47d8-b376-ba72186e25b3": {
        "affectedByModifierIds": [],
        "cooldown": 25,
        "game_id": 1044,
        "icon_name": "spell_holy_sealofvalor",
        "id": "c90b5bf9-7ffc-47d8-b376-ba72186e25b3",
        "name": "Blessing of Freedom",
        "shortName": "Free"
      },
      "c93d1c28-2dae-4e36-a5a0-cea6186e46e8": {
        "affectedByModifierIds": [],
        "cooldown": 120,
        "game_id": 32375,
        "icon_name": "spell_arcane_massdispel",
        "id": "c93d1c28-2dae-4e36-a5a0-cea6186e46e8",
        "name": "Mass Dispel",
        "shortName": "Mass",
        "talentId": "86967fd5-a1d9-4a28-95ba-4726fbd78e88"
      },
      "cb77a43e-809f-4e05-84ad-9c81db717cd7": {
        "affectedByModifierIds": [],
        "cooldown": 25,
        "game_id": 1044,
        "icon_name": "spell_holy_sealofvalor",
        "id": "cb77a43e-809f-4e05-84ad-9c81db717cd7",
        "name": "Blessing of Freedom",
        "shortName": "Free"
      },
      "cea5efd9-784b-4905-aa57-877f6c079224": {
        "affectedByModifierIds": [],
        "cooldown": 120,
        "game_id": 32375,
        "icon_name": "spell_arcane_massdispel",
        "id": "cea5efd9-784b-4905-aa57-877f6c079224",
        "name": "Mass Dispel",
        "shortName": "Mass",
        "talentId": "60239fe4-730f-4e48-b76a-b6dfcf2e849c"
      },
      "d1cb7755-045b-42d3-b61d-1e77bf93e2ab": {
        "affectedByModifierIds": [],
        "cooldown": 1000,
        "game_id": 6262,
        "icon_name": "warlock_-healthstone",
        "id": "d1cb7755-045b-42d3-b61d-1e77bf93e2ab",
        "name": "Healthstone",
        "shortName": "HS",
        "talentId": "6923f864-ad8f-4925-9a84-070df62696f7"
      },
      "d1e7f489-2653-4e4c-a515-30c7a5276797": {
        "affectedByModifierIds": [],
        "cooldown": 300,
        "game_id": 642,
        "icon_name": "spell_holy_divineshield",
        "id": "d1e7f489-2653-4e4c-a515-30c7a5276797",
        "name": "Divine Shield",
        "shortName": "Div"
      },
      "d6c91c73-29d6-4f19-924a-ac4c629e7ac0": {
        "affectedByModifierIds": [],
        "cooldown": 60,
        "game_id": 123040,
        "icon_name": "spell_shadow_soulleech_3",
        "id": "d6c91c73-29d6-4f19-924a-ac4c629e7ac0",
        "name": "Mindbender",
        "shortName": "Bender",
        "talentId": "86a57591-e264-4ff6-8343-effad90ccf46"
      },
      "dad553bd-8fd7-424f-aec1-2deb23df82d1": {
        "affectedByModifierIds": [],
        "cooldown": 180,
        "game_id": 114052,
        "icon_name": "spell_fire_elementaldevastation",
        "id": "dad553bd-8fd7-424f-aec1-2deb23df82d1",
        "name": "Ascendance",
        "shortName": "Asc",
        "talentId": "d00ae128-a28d-45d4-a73a-933972f4d8e7"
      },
      "dd8fb0eb-9eb6-409b-8273-3c385272cdd1": {
        "affectedByModifierIds": [],
        "cooldown": 180,
        "game_id": 64843,
        "icon_name": "spell_holy_divinehymn",
        "id": "dd8fb0eb-9eb6-409b-8273-3c385272cdd1",
        "name": "Divine Hymn",
        "shortName": "Hymn"
      },
      "de825485-2096-4c97-ac2f-b6d52a890970": {
        "affectedByModifierIds": [],
        "cooldown": 120,
        "game_id": 383269,
        "icon_name": "ability_maldraxxus_deathknight",
        "id": "de825485-2096-4c97-ac2f-b6d52a890970",
        "link_suffix": "",
        "name": "Abomination Limb",
        "shortName": "Abom",
        "talentId": "29c3a6b1-c239-4c62-8cbc-17851246f2ca"
      },
      "df390fec-d40e-440c-95d6-b1674dd93db2": {
        "affectedByModifierIds": [],
        "cooldown": 180,
        "game_id": 64901,
        "icon_name": "spell_holy_symbolofhope",
        "id": "df390fec-d40e-440c-95d6-b1674dd93db2",
        "name": "Symbol of Hope",
        "shortName": "Hope"
      },
      "e04f6bed-54d6-4ccd-b284-fd5302e98106": {
        "affectedByModifierIds": [],
        "cooldown": 120,
        "game_id": 51052,
        "icon_name": "spell_deathknight_antimagiczone",
        "id": "e04f6bed-54d6-4ccd-b284-fd5302e98106",
        "name": "Anti-Magic Zone",
        "shortName": "AMZ"
      },
      "e2008809-fa49-45f5-88cc-69d69f09d3f7": {
        "affectedByModifierIds": [],
        "cooldown": 120,
        "game_id": 374227,
        "icon_name": "ability_evoker_hoverblack",
        "id": "e2008809-fa49-45f5-88cc-69d69f09d3f7",
        "name": "Zephyr",
        "shortName": "Zeph",
        "talentId": "a7e35d51-0b24-459f-a910-3c171a1f1c2c"
      },
      "e3e67a81-8897-4358-a78e-a9d2f4a052f4": {
        "affectedByModifierIds": [],
        "cooldown": 120,
        "game_id": 406732,
        "icon_name": "ability_evoker_stretchtime",
        "id": "e3e67a81-8897-4358-a78e-a9d2f4a052f4",
        "name": "Spatial Paradox",
        "shortName": "Para",
        "talentId": "b1b64ce1-49d1-4fa5-b047-fc83e85a6f49"
      },
      "e4351f7c-0801-42d7-ba5c-22b53dbe7b63": {
        "affectedByModifierIds": [],
        "cooldown": 300,
        "game_id": 196718,
        "icon_name": "ability_demonhunter_darkness",
        "id": "e4351f7c-0801-42d7-ba5c-22b53dbe7b63",
        "link_suffix": "",
        "name": "Darkness",
        "shortName": "Dark",
        "talentId": "942880fa-5ba3-4a7e-9fc7-66f0c1eaa773"
      },
      "e793cd57-8d6b-450d-922f-b7f8ecdaccde": {
        "affectedByModifierIds": [],
        "cooldown": 120,
        "game_id": 108199,
        "icon_name": "ability_deathknight_aoedeathgrip",
        "id": "e793cd57-8d6b-450d-922f-b7f8ecdaccde",
        "link_suffix": "",
        "name": "Gorefiend's Grasp",
        "shortName": "Grasp",
        "talentId": "ef60d47b-0057-4d36-b70e-2da0c78f7f60"
      },
      "e808a728-ffb6-4144-b3de-3814260fdb3e": {
        "affectedByModifierIds": [],
        "cooldown": 60,
        "game_id": 370665,
        "icon_name": "ability_evoker_flywithme",
        "id": "e808a728-ffb6-4144-b3de-3814260fdb3e",
        "name": "Rescue",
        "shortName": "Resc",
        "talentId": "d12ab590-e070-4499-a46b-8f8d9f6d87f9"
      },
      "e8c809f2-403c-4a1c-931d-3d098d0b4be4": {
        "affectedByModifierIds": [],
        "cooldown": 240,
        "game_id": 363534,
        "icon_name": "ability_evoker_rewind",
        "id": "e8c809f2-403c-4a1c-931d-3d098d0b4be4",
        "name": "Rewind",
        "shortName": "Rew"
      },
      "e8db7730-679d-4b50-947c-73256902fb94": {
        "affectedByModifierIds": [],
        "cooldown": 120,
        "game_id": 192077,
        "icon_name": "ability_shaman_windwalktotem",
        "id": "e8db7730-679d-4b50-947c-73256902fb94",
        "name": "Wind Rush Totem",
        "shortName": "WRT",
        "talentId": "b0609c1f-80fb-4d7e-8575-748119151e7c"
      },
      "e9f4a649-58c3-48e2-b922-61319b1a97d8": {
        "affectedByModifierIds": [],
        "cooldown": 60,
        "game_id": 102793,
        "icon_name": "spell_druid_ursolsvortex",
        "id": "e9f4a649-58c3-48e2-b922-61319b1a97d8",
        "link_suffix": "",
        "name": "Ursol's Vortex",
        "shortName": "Vor",
        "talentId": "c50dc21e-810f-40a8-b0d3-2253e8bb292f"
      },
      "ec902111-72bb-4274-9d26-ac9e525cdba3": {
        "affectedByModifierIds": [],
        "cooldown": 90,
        "game_id": 102342,
        "icon_name": "spell_druid_ironbark",
        "id": "ec902111-72bb-4274-9d26-ac9e525cdba3",
        "name": "Ironbark",
        "shortName": "IB"
      },
      "ecbd7b52-095c-4235-ba4f-cac68ed81f07": {
        "affectedByModifierIds": [],
        "cooldown": 25,
        "game_id": 1044,
        "icon_name": "spell_holy_sealofvalor",
        "id": "ecbd7b52-095c-4235-ba4f-cac68ed81f07",
        "name": "Blessing of Freedom",
        "shortName": "Free",
        "talentId": "29e5b934-702a-49b8-896a-3bae79e4570c"
      },
      "ed3afda4-ab7a-4d18-8768-197c47df876c": {
        "affectedByModifierIds": [],
        "cooldown": 120,
        "game_id": 15286,
        "icon_name": "spell_shadow_unsummonbuilding",
        "id": "ed3afda4-ab7a-4d18-8768-197c47df876c",
        "link_suffix": "",
        "name": "Vampiric Embrace",
        "shortName": "Vamp",
        "talentId": "2b72b7a8-5225-4cf8-9869-e155b771c0ab"
      },
      "f1ce058f-96aa-412b-a8da-14fc74d5c6f8": {
        "affectedByModifierIds": [],
        "cooldown": 180,
        "game_id": 108285,
        "icon_name": "ability_shaman_multitotemactivation",
        "id": "f1ce058f-96aa-412b-a8da-14fc74d5c6f8",
        "link_suffix": "",
        "name": "Totemic Recall",
        "shortName": "Recall",
        "talentId": "39b7ba4f-f3f1-4c88-9869-2d19d08b6722"
      },
      "f7710243-7665-432d-af2a-565c91498eb1": {
        "affectedByModifierIds": [],
        "cooldown": 120,
        "game_id": 374968,
        "icon_name": "ability_evoker_timespiral",
        "id": "f7710243-7665-432d-af2a-565c91498eb1",
        "name": "Time Spiral",
        "shortName": "Spiral",
        "talentId": "cac23db6-fdaa-4d74-874f-ef7e48f654a3"
      },
      "f9c6752f-572b-4279-a184-2ebb993610b6": {
        "affectedByModifierIds": [],
        "cooldown": 300,
        "game_id": 642,
        "icon_name": "spell_holy_divineshield",
        "id": "f9c6752f-572b-4279-a184-2ebb993610b6",
        "name": "Divine Shield",
        "shortName": "Div"
      },
      "fa3e4f83-f25b-4123-aec6-5f3585937938": {
        "affectedByModifierIds": [],
        "cooldown": 120,
        "game_id": 106898,
        "icon_name": "spell_druid_stampedingroar_cat",
        "id": "fa3e4f83-f25b-4123-aec6-5f3585937938",
        "name": "Stampeding Roar",
        "shortName": "Roar"
      },
      "fd916eb4-325b-407a-88bf-0edf172a5e76": {
        "affectedByModifierIds": [],
        "cooldown": 180,
        "game_id": 16191,
        "icon_name": "ability_shaman_manatidetotem",
        "id": "fd916eb4-325b-407a-88bf-0edf172a5e76",
        "name": "Mana Tide Totem",
        "shortName": "MTT",
        "talentId": "c51067a1-5b8b-4e69-a1fe-fba2b257a695"
      },
      "fedce7ea-cda3-412e-84ba-1e9a5f98a996": {
        "affectedByModifierIds": [],
        "cooldown": 180,
        "game_id": 97462,
        "icon_name": "ability_warrior_rallyingcry",
        "id": "fedce7ea-cda3-412e-84ba-1e9a5f98a996",
        "name": "Rallying Cry",
        "shortName": "RC"
      }
    },
    "talentsById": {
      "0443895f-c5d7-4ac4-ae1a-0fc356481c36": {
        "game_id": 192077,
        "icon_name": "ability_shaman_windwalktotem",
        "id": "0443895f-c5d7-4ac4-ae1a-0fc356481c36",
        "name": "Wind Rush Totem",
        "shortName": "WRT",
        "specId": "af2ca3dc-34c9-4632-98d2-6ea12a2a72f9"
      },
      "0664d053-620c-4a9a-8b81-b5708d613ecd": {
        "game_id": 344359,
        "icon_name": "ability_monk_dpsstance",
        "id": "0664d053-620c-4a9a-8b81-b5708d613ecd",
        "link_suffix": "?def=129821&rank=1",
        "name": "Ancient Arts (1/2)",
        "shortName": "Arts",
        "specId": "18dad85c-ac2c-4aac-b0f8-e0fc4b8633e6"
      },
      "0681053e-7a87-42d2-bbb6-3040dec74a0f": {
        "game_id": 266921,
        "icon_name": "ability_hunter_aspectoftheviper",
        "id": "0681053e-7a87-42d2-bbb6-3040dec74a0f",
        "name": "Born To Be Wild",
        "shortName": "BtbW",
        "specId": "34b5a797-05ef-4431-91a0-64cc76a97624"
      },
      "07cab4a9-2332-45e0-a119-728f2fa001ad": {
        "game_id": 414660,
        "icon_name": "ability_racial_magicalresistance",
        "id": "07cab4a9-2332-45e0-a119-728f2fa001ad",
        "name": "Mass Barrier",
        "shortName": "Barrier",
        "specId": "7f8d7fab-f5cc-4d47-9212-565bab25aeed"
      },
      "08934f1c-beda-433f-aa24-8c7056f190de": {
        "game_id": 378425,
        "icon_name": "spell_holy_greaterblessingofsalvation",
        "id": "08934f1c-beda-433f-aa24-8c7056f190de",
        "link_suffix": "?def=107474&rank=2",
        "name": "Uther's Counsel (2/2)",
        "shortName": "Counsel",
        "specId": "8fceebcc-a93b-4692-81ea-331b2e59d43d"
      },
      "0b20bfaa-6d9b-4d48-82ab-91e8bfa0a0ae": {
        "game_id": 375576,
        "icon_name": "ability_bastion_paladin",
        "id": "0b20bfaa-6d9b-4d48-82ab-91e8bfa0a0ae",
        "name": "Divine Toll",
        "shortName": "Toll",
        "specId": "e1af3b62-ddf5-4369-a528-dab8ab94d366"
      },
      "0ed2857e-162c-4655-a874-0e1bd27d580c": {
        "game_id": 124974,
        "icon_name": "achievement_zone_feralas",
        "id": "0ed2857e-162c-4655-a874-0e1bd27d580c",
        "name": "Nature's Vigil",
        "shortName": "Vigil",
        "specId": "be905ae2-ec32-49bf-bc82-ef1cbf83ce9f"
      },
      "12c8bd27-583f-4962-a64e-1e679884f2ba": {
        "game_id": 200209,
        "icon_name": "ability_priest_pathofthedevout",
        "id": "12c8bd27-583f-4962-a64e-1e679884f2ba",
        "name": "Guardian Angel",
        "shortName": "GA",
        "specId": "d122a0b5-d857-4bc5-a456-c7250f8f6690"
      },
      "13c1b475-07ae-47ae-8c40-f8f6e8c65b80": {
        "game_id": 216331,
        "icon_name": "ability_paladin_veneration",
        "id": "13c1b475-07ae-47ae-8c40-f8f6e8c65b80",
        "name": "Avenging Crusader",
        "shortName": "Crusa",
        "specId": "e1af3b62-ddf5-4369-a528-dab8ab94d366"
      },
      "19b8b476-3bf6-4ea2-8c39-78421f6a4c42": {
        "game_id": 102793,
        "icon_name": "spell_druid_ursolsvortex",
        "id": "19b8b476-3bf6-4ea2-8c39-78421f6a4c42",
        "link_suffix": "",
        "name": "Ursol's Vortex",
        "shortName": "Vor",
        "specId": "6c233e8c-5bd4-4ece-9fb8-529a1e78759b"
      },
      "1ad4605f-1098-4c6c-96ee-dad6e503dbfa": {
        "game_id": 384820,
        "icon_name": "spell_holy_sealofsacrifice",
        "id": "1ad4605f-1098-4c6c-96ee-dad6e503dbfa",
        "name": "Sacrifice of the Just",
        "shortName": "Just",
        "specId": "8fceebcc-a93b-4692-81ea-331b2e59d43d"
      },
      "1db88ec3-6ff2-45a0-9d6d-3f6565666ec5": {
        "game_id": 374383,
        "icon_name": "spell_deathknight_antimagiczone",
        "id": "1db88ec3-6ff2-45a0-9d6d-3f6565666ec5",
        "link_suffix": "",
        "name": "Assimilation",
        "shortName": "Assi",
        "specId": "1b478900-c50e-49f6-b9b1-d2fedfb10c2b"
      },
      "1ef6a0a8-330f-4ae0-b6ac-b16ff8175985": {
        "game_id": 414660,
        "icon_name": "ability_racial_magicalresistance",
        "id": "1ef6a0a8-330f-4ae0-b6ac-b16ff8175985",
        "name": "Mass Barrier",
        "shortName": "Barrier",
        "specId": "ab48ab5c-dfb9-4ce9-9557-8d0ce5129df2"
      },
      "20669b18-9b9c-4a70-8897-7d2d78dbbd9c": {
        "game_id": 102793,
        "icon_name": "spell_druid_ursolsvortex",
        "id": "20669b18-9b9c-4a70-8897-7d2d78dbbd9c",
        "link_suffix": "",
        "name": "Ursol's Vortex",
        "shortName": "Vor",
        "specId": "72947601-4270-4e1e-b917-25aacaa6d3e0"
      },
      "209202d5-1098-4b82-a57d-c9fb9b2fa3bc": {
        "game_id": 381867,
        "icon_name": "spell_nature_agitatingtotem",
        "id": "209202d5-1098-4b82-a57d-c9fb9b2fa3bc",
        "link_suffix": "",
        "name": "Totemic Surge",
        "shortName": "TS",
        "specId": "1df0b300-a31e-4ebc-be57-a909f82bab4b"
      },
      "21fbcd60-b5fa-4da4-ba8f-323f142dcecf": {
        "game_id": 196718,
        "icon_name": "ability_demonhunter_darkness",
        "id": "21fbcd60-b5fa-4da4-ba8f-323f142dcecf",
        "link_suffix": "",
        "name": "Darkness",
        "shortName": "Dark",
        "specId": "08853913-0c47-4ca1-aec0-e93206a6ee45"
      },
      "23575f08-d1ae-4f0c-89a1-35de86cd38d3": {
        "game_id": 383011,
        "icon_name": "ability_shaman_multitotemactivation",
        "id": "23575f08-d1ae-4f0c-89a1-35de86cd38d3",
        "link_suffix": "",
        "name": "Call of the Elements",
        "shortName": "CotE",
        "specId": "af2ca3dc-34c9-4632-98d2-6ea12a2a72f9"
      },
      "23a727ed-218c-4d15-ab63-59c52a812cc3": {
        "game_id": 124974,
        "icon_name": "achievement_zone_feralas",
        "id": "23a727ed-218c-4d15-ab63-59c52a812cc3",
        "name": "Nature's Vigil",
        "shortName": "Vigil",
        "specId": "575905ae-cdc7-44c8-946c-861d50111b6d"
      },
      "24301623-78be-4acd-90a5-52ebfa22b21e": {
        "game_id": 108285,
        "icon_name": "ability_shaman_multitotemactivation",
        "id": "24301623-78be-4acd-90a5-52ebfa22b21e",
        "link_suffix": "",
        "name": "Totemic Recall",
        "shortName": "Recall",
        "specId": "af2ca3dc-34c9-4632-98d2-6ea12a2a72f9"
      },
      "2748443f-7a4b-4590-8247-f2a1e8012497": {
        "game_id": 73325,
        "icon_name": "priest_spell_leapoffaith_a",
        "id": "2748443f-7a4b-4590-8247-f2a1e8012497",
        "name": "Leap of Faith",
        "shortName": "Leap",
        "specId": "d122a0b5-d857-4bc5-a456-c7250f8f6690"
      },
      "276404dc-75ba-4a51-ab87-e243c200c27c": {
        "game_id": 197073,
        "icon_name": "ability_druid_dreamstate",
        "id": "276404dc-75ba-4a51-ab87-e243c200c27c",
        "name": "Inner Peace",
        "shortName": "IP",
        "specId": "72947601-4270-4e1e-b917-25aacaa6d3e0"
      },
      "29c3a6b1-c239-4c62-8cbc-17851246f2ca": {
        "game_id": 383269,
        "icon_name": "ability_maldraxxus_deathknight",
        "id": "29c3a6b1-c239-4c62-8cbc-17851246f2ca",
        "link_suffix": "",
        "name": "Abomination Limb",
        "shortName": "Abom",
        "specId": "b72fb4f9-413a-4222-8569-b3cb8e5e67f2"
      },
      "29e5b934-702a-49b8-896a-3bae79e4570c": {
        "game_id": 1044,
        "icon_name": "spell_holy_sealofvalor",
        "id": "29e5b934-702a-49b8-896a-3bae79e4570c",
        "name": "Blessing of Freedom",
        "shortName": "Free",
        "specId": "8fceebcc-a93b-4692-81ea-331b2e59d43d"
      },
      "2ac4e358-e222-4c2e-81ea-67d0a1878997": {
        "game_id": 414660,
        "icon_name": "ability_racial_magicalresistance",
        "id": "2ac4e358-e222-4c2e-81ea-67d0a1878997",
        "name": "Mass Barrier",
        "shortName": "Barrier",
        "specId": "a022f6ed-2b4e-4ddf-a7e9-7fb746f5adc2"
      },
      "2b72b7a8-5225-4cf8-9869-e155b771c0ab": {
        "game_id": 15286,
        "icon_name": "spell_shadow_unsummonbuilding",
        "id": "2b72b7a8-5225-4cf8-9869-e155b771c0ab",
        "link_suffix": "",
        "name": "Vampiric Embrace",
        "shortName": "Vamp",
        "specId": "48c27d79-2cc2-4674-bfd0-9a471f6c7ced"
      },
      "2f0bd1e5-b6a6-4f22-9eb5-b7cc2764e42d": {
        "game_id": 47788,
        "icon_name": "spell_holy_guardianspirit",
        "id": "2f0bd1e5-b6a6-4f22-9eb5-b7cc2764e42d",
        "name": "Guardian Spirit",
        "shortName": "GS",
        "specId": "d122a0b5-d857-4bc5-a456-c7250f8f6690"
      },
      "3132878e-6050-46fa-8123-34b4140cc5a6": {
        "game_id": 462791,
        "icon_name": "achievement_raidprimalist_windelemental",
        "id": "3132878e-6050-46fa-8123-34b4140cc5a6",
        "link_suffix": "",
        "name": "Ascending Air",
        "shortName": "Air",
        "specId": "1df0b300-a31e-4ebc-be57-a909f82bab4b"
      },
      "3199ce60-fc5a-401e-a04a-ff6c16d09c8a": {
        "game_id": 404015,
        "icon_name": "ability_shaman_healingtide",
        "id": "3199ce60-fc5a-401e-a04a-ff6c16d09c8a",
        "link_suffix": "",
        "name": "Current Control",
        "shortName": "CC",
        "specId": "51daa0f0-df16-4983-ae44-e11b5f9b3edb"
      },
      "323aa9a7-d433-40b0-a1e0-4ec13062af41": {
        "game_id": 462791,
        "icon_name": "achievement_raidprimalist_windelemental",
        "id": "323aa9a7-d433-40b0-a1e0-4ec13062af41",
        "link_suffix": "",
        "name": "Ascending Air",
        "shortName": "Air",
        "specId": "51daa0f0-df16-4983-ae44-e11b5f9b3edb"
      },
      "32afdfd0-fcbc-42b7-aa73-d5a0a182c250": {
        "game_id": 102793,
        "icon_name": "spell_druid_ursolsvortex",
        "id": "32afdfd0-fcbc-42b7-aa73-d5a0a182c250",
        "link_suffix": "",
        "name": "Ursol's Vortex",
        "shortName": "Vor",
        "specId": "be905ae2-ec32-49bf-bc82-ef1cbf83ce9f"
      },
      "34f9cd41-943d-4938-b700-487a4ae91dc6": {
        "game_id": 390620,
        "icon_name": "ability_priest_savinggrace",
        "id": "34f9cd41-943d-4938-b700-487a4ae91dc6",
        "name": "Move with Grace",
        "shortName": "Grace",
        "specId": "48c27d79-2cc2-4674-bfd0-9a471f6c7ced"
      },
      "3725d5f9-9f0d-4247-b601-593641f2b400": {
        "game_id": 370960,
        "icon_name": "ability_evoker_green_01",
        "id": "3725d5f9-9f0d-4247-b601-593641f2b400",
        "name": "Emerald Communion",
        "shortName": "Com",
        "specId": "48a205f0-5e24-4382-9e0b-3c06cfc1b873"
      },
      "387731b9-c4fd-4f4b-81c5-a5fe97b6ca8e": {
        "game_id": 462791,
        "icon_name": "achievement_raidprimalist_windelemental",
        "id": "387731b9-c4fd-4f4b-81c5-a5fe97b6ca8e",
        "link_suffix": "",
        "name": "Ascending Air",
        "shortName": "Air",
        "specId": "af2ca3dc-34c9-4632-98d2-6ea12a2a72f9"
      },
      "39b7ba4f-f3f1-4c88-9869-2d19d08b6722": {
        "game_id": 108285,
        "icon_name": "ability_shaman_multitotemactivation",
        "id": "39b7ba4f-f3f1-4c88-9869-2d19d08b6722",
        "link_suffix": "",
        "name": "Totemic Recall",
        "shortName": "Recall",
        "specId": "1df0b300-a31e-4ebc-be57-a909f82bab4b"
      },
      "3a8b4082-7e3f-4769-9aef-0afb0c6218c0": {
        "game_id": 1022,
        "icon_name": "spell_holy_sealofprotection",
        "id": "3a8b4082-7e3f-4769-9aef-0afb0c6218c0",
        "name": "Blessing of Protection",
        "shortName": "BoP",
        "specId": "e1af3b62-ddf5-4369-a528-dab8ab94d366"
      },
      "3a9532a9-1628-48e5-bfa5-6c86f01e984b": {
        "game_id": 10060,
        "icon_name": "spell_holy_powerinfusion",
        "id": "3a9532a9-1628-48e5-bfa5-6c86f01e984b",
        "name": "Power Infusion",
        "shortName": "PI",
        "specId": "d122a0b5-d857-4bc5-a456-c7250f8f6690"
      },
      "3bb079c8-2c07-4ae3-916f-b613cd94dce0": {
        "game_id": 384909,
        "icon_name": "spell_holy_sealofprotection",
        "id": "3bb079c8-2c07-4ae3-916f-b613cd94dce0",
        "name": "Improved Blessing of Protection",
        "shortName": "Imp Blessing",
        "specId": "e1af3b62-ddf5-4369-a528-dab8ab94d366"
      },
      "3ff77a62-6e49-4f1b-a57e-633531b12d51": {
        "game_id": 374968,
        "icon_name": "ability_evoker_timespiral",
        "id": "3ff77a62-6e49-4f1b-a57e-633531b12d51",
        "name": "Time Spiral",
        "shortName": "Spiral",
        "specId": "e6b1de69-ce2c-467c-ae7a-e1613ba23fb9"
      },
      "43e9d1e3-6222-49a9-885d-e5ef18895d51": {
        "game_id": 325197,
        "icon_name": "inv_pet_cranegod",
        "id": "43e9d1e3-6222-49a9-885d-e5ef18895d51",
        "name": "Invoke Chi-Ji, the Red Crane",
        "shortName": "Chi",
        "specId": "da2dc773-9412-4b11-ab2b-7d06e200b9d3"
      },
      "47a49203-fab9-45e1-83f9-8e8d05610884": {
        "game_id": 200183,
        "icon_name": "ability_priest_ascension",
        "id": "47a49203-fab9-45e1-83f9-8e8d05610884",
        "link_suffix": "",
        "name": "Apotheosis",
        "shortName": "Apo",
        "specId": "d122a0b5-d857-4bc5-a456-c7250f8f6690"
      },
      "4c69476f-cbfc-4ab4-90c4-77d7994672b3": {
        "game_id": 384820,
        "icon_name": "spell_holy_sealofsacrifice",
        "id": "4c69476f-cbfc-4ab4-90c4-77d7994672b3",
        "name": "Sacrifice of the Just",
        "shortName": "Just",
        "specId": "e1af3b62-ddf5-4369-a528-dab8ab94d366"
      },
      "536d0677-f2da-4049-a994-781dc6f0fdb5": {
        "game_id": 344359,
        "icon_name": "ability_monk_dpsstance",
        "id": "536d0677-f2da-4049-a994-781dc6f0fdb5",
        "link_suffix": "?def=129821&rank=2",
        "name": "Ancient Arts (2/2)",
        "shortName": "Arts",
        "specId": "88f4a6b5-7766-41c3-b824-fbba531a2c8e"
      },
      "54a7aa89-b5e0-47c4-923f-553cce4af783": {
        "game_id": 29166,
        "icon_name": "spell_nature_lightning",
        "id": "54a7aa89-b5e0-47c4-923f-553cce4af783",
        "name": "Innervate",
        "shortName": "Inn",
        "specId": "be905ae2-ec32-49bf-bc82-ef1cbf83ce9f"
      },
      "55d279c4-3b32-48bc-afe6-fba03504e6f8": {
        "game_id": 32375,
        "icon_name": "spell_arcane_massdispel",
        "id": "55d279c4-3b32-48bc-afe6-fba03504e6f8",
        "name": "Mass Dispel",
        "shortName": "Mass",
        "specId": "67a45712-192e-4916-ad57-d9a13124fea6"
      },
      "56c44c32-56d3-4b05-b190-d081d7d92887": {
        "game_id": 389783,
        "icon_name": "sha_spell_warlock_demonsoul",
        "id": "56c44c32-56d3-4b05-b190-d081d7d92887",
        "name": "Pitch Black",
        "shortName": "Pitch",
        "specId": "c95c2375-57fa-4ae8-9d55-c2e939b82247"
      },
      "57257465-dc2e-4329-8aa5-654ab01cafdd": {
        "game_id": 344359,
        "icon_name": "ability_monk_dpsstance",
        "id": "57257465-dc2e-4329-8aa5-654ab01cafdd",
        "link_suffix": "?def=129821&rank=1",
        "name": "Ancient Arts (1/2)",
        "shortName": "Arts",
        "specId": "da2dc773-9412-4b11-ab2b-7d06e200b9d3"
      },
      "583c8125-aa0f-4233-b00e-148483c8f430": {
        "game_id": 288826,
        "icon_name": "spell_druid_stamedingroar",
        "id": "583c8125-aa0f-4233-b00e-148483c8f430",
        "name": "Improved Stampeding Roar",
        "shortName": "Imp. Roar",
        "specId": "575905ae-cdc7-44c8-946c-861d50111b6d"
      },
      "5ae9580e-cb49-4e4f-aa6d-9d17c56aaf38": {
        "game_id": 266921,
        "icon_name": "ability_hunter_aspectoftheviper",
        "id": "5ae9580e-cb49-4e4f-aa6d-9d17c56aaf38",
        "name": "Born To Be Wild",
        "shortName": "BtbW",
        "specId": "0c9d68bc-e126-4a07-817a-72c37094e005"
      },
      "5bfef2d9-ac8d-4ab7-8130-c189613aecf5": {
        "game_id": 390620,
        "icon_name": "ability_priest_savinggrace",
        "id": "5bfef2d9-ac8d-4ab7-8130-c189613aecf5",
        "name": "Move with Grace",
        "shortName": "Grace",
        "specId": "d122a0b5-d857-4bc5-a456-c7250f8f6690"
      },
      "5ce5c461-8ec9-4c67-84e7-14c9c4a49c91": {
        "game_id": 462440,
        "icon_name": "spell_shaman_astralshift",
        "id": "5ce5c461-8ec9-4c67-84e7-14c9c4a49c91",
        "link_suffix": "",
        "name": "First Ascendant",
        "shortName": "FA",
        "specId": "51daa0f0-df16-4983-ae44-e11b5f9b3edb"
      },
      "5e19c74d-51bf-4a6c-b4ae-4062092545c7": {
        "game_id": 384820,
        "icon_name": "spell_holy_sealofsacrifice",
        "id": "5e19c74d-51bf-4a6c-b4ae-4062092545c7",
        "name": "Sacrifice of the Just",
        "shortName": "Just",
        "specId": "4ac0a1e4-3352-49e9-b455-faa83312526d"
      },
      "5f356c9e-aa59-4134-ba94-ba4e0eb365d3": {
        "game_id": 108285,
        "icon_name": "ability_shaman_multitotemactivation",
        "id": "5f356c9e-aa59-4134-ba94-ba4e0eb365d3",
        "link_suffix": "",
        "name": "Totemic Recall",
        "shortName": "Recall",
        "specId": "51daa0f0-df16-4983-ae44-e11b5f9b3edb"
      },
      "60239fe4-730f-4e48-b76a-b6dfcf2e849c": {
        "game_id": 32375,
        "icon_name": "spell_arcane_massdispel",
        "id": "60239fe4-730f-4e48-b76a-b6dfcf2e849c",
        "name": "Mass Dispel",
        "shortName": "Mass",
        "specId": "d122a0b5-d857-4bc5-a456-c7250f8f6690"
      },
      "60d405ec-59b6-412a-930e-ae796cc44bab": {
        "game_id": 381922,
        "icon_name": "ability_evoker_rewind",
        "id": "60d405ec-59b6-412a-930e-ae796cc44bab",
        "name": "Temporal Artificer",
        "shortName": "Temp. Art",
        "specId": "48a205f0-5e24-4382-9e0b-3c06cfc1b873"
      },
      "62c3849f-7ce6-49b0-878c-3ffd80cc0cfa": {
        "game_id": 370665,
        "icon_name": "ability_evoker_flywithme",
        "id": "62c3849f-7ce6-49b0-878c-3ffd80cc0cfa",
        "name": "Rescue",
        "shortName": "Resc",
        "specId": "e6b1de69-ce2c-467c-ae7a-e1613ba23fb9"
      },
      "6467fbd3-c882-4737-a3b0-eb61173588d0": {
        "game_id": 29166,
        "icon_name": "spell_nature_lightning",
        "id": "6467fbd3-c882-4737-a3b0-eb61173588d0",
        "name": "Innervate",
        "shortName": "Inn",
        "specId": "6c233e8c-5bd4-4ece-9fb8-529a1e78759b"
      },
      "661685eb-b5c8-4805-9a1b-f243c3d7d207": {
        "game_id": 383011,
        "icon_name": "ability_shaman_multitotemactivation",
        "id": "661685eb-b5c8-4805-9a1b-f243c3d7d207",
        "link_suffix": "",
        "name": "Call of the Elements",
        "shortName": "CotE",
        "specId": "1df0b300-a31e-4ebc-be57-a909f82bab4b"
      },
      "68c4840d-d722-4111-9259-d609d2a47a8d": {
        "game_id": 288826,
        "icon_name": "spell_druid_stamedingroar",
        "id": "68c4840d-d722-4111-9259-d609d2a47a8d",
        "name": "Improved Stampeding Roar",
        "shortName": "Imp. Roar",
        "specId": "72947601-4270-4e1e-b917-25aacaa6d3e0"
      },
      "6923f864-ad8f-4925-9a84-070df62696f7": {
        "game_id": 6262,
        "icon_name": "warlock_-healthstone",
        "id": "6923f864-ad8f-4925-9a84-070df62696f7",
        "name": "Healthstone",
        "shortName": "HS",
        "specId": "ab48ab5c-dfb9-4ce9-9557-8d0ce5129df2"
      },
      "697468b8-0ac6-4eac-a025-e2c8add98f9a": {
        "game_id": 202424,
        "icon_name": "ability_monk_domeofmist",
        "id": "697468b8-0ac6-4eac-a025-e2c8add98f9a",
        "name": "Chrysalis",
        "shortName": "Chrys",
        "specId": "da2dc773-9412-4b11-ab2b-7d06e200b9d3"
      },
      "69827ab3-42ef-4913-a09e-b923d37bf960": {
        "game_id": 29166,
        "icon_name": "spell_nature_lightning",
        "id": "69827ab3-42ef-4913-a09e-b923d37bf960",
        "name": "Innervate",
        "shortName": "Inn",
        "specId": "575905ae-cdc7-44c8-946c-861d50111b6d"
      },
      "69be9306-608e-4446-be1e-cc51ea80988d": {
        "game_id": 359816,
        "icon_name": "ability_evoker_dreamflight",
        "id": "69be9306-608e-4446-be1e-cc51ea80988d",
        "name": "Dream Flight",
        "shortName": "Dream",
        "specId": "48a205f0-5e24-4382-9e0b-3c06cfc1b873"
      },
      "6e4d7e5b-8a41-4dae-aca0-5ba062d951f9": {
        "game_id": 206970,
        "icon_name": "spell_shadow_coneofsilence",
        "id": "6e4d7e5b-8a41-4dae-aca0-5ba062d951f9",
        "link_suffix": "",
        "name": "Tightening Grasp",
        "shortName": "Tight Grasp",
        "specId": "34735ecf-bf9e-4225-bb6e-ee617b024b70"
      },
      "7010c6b1-7294-42c2-83f9-41a824dd50b3": {
        "game_id": 374227,
        "icon_name": "ability_evoker_hoverblack",
        "id": "7010c6b1-7294-42c2-83f9-41a824dd50b3",
        "name": "Zephyr",
        "shortName": "Zeph",
        "specId": "e6b1de69-ce2c-467c-ae7a-e1613ba23fb9"
      },
      "785b2684-c8e9-49d8-bc0d-345e37f22848": {
        "game_id": 10060,
        "icon_name": "spell_holy_powerinfusion",
        "id": "785b2684-c8e9-49d8-bc0d-345e37f22848",
        "name": "Power Infusion",
        "shortName": "PI",
        "specId": "67a45712-192e-4916-ad57-d9a13124fea6"
      },
      "7aa9aea3-7f0e-4875-9ef6-04e6ccabcfde": {
        "game_id": 393371,
        "icon_name": "ability_druid_treeoflife",
        "id": "7aa9aea3-7f0e-4875-9ef6-04e6ccabcfde",
        "name": "Cenarius' Guidance",
        "shortName": "Guide",
        "specId": "72947601-4270-4e1e-b917-25aacaa6d3e0"
      },
      "7d92941f-be8d-4993-a845-2787dbd3e8e3": {
        "game_id": 288826,
        "icon_name": "spell_druid_stamedingroar",
        "id": "7d92941f-be8d-4993-a845-2787dbd3e8e3",
        "name": "Improved Stampeding Roar",
        "shortName": "Imp. Roar",
        "specId": "be905ae2-ec32-49bf-bc82-ef1cbf83ce9f"
      },
      "7ed586dd-19c5-46e7-be0e-0bd9b4564584": {
        "game_id": 116841,
        "icon_name": "ability_monk_tigerslust",
        "id": "7ed586dd-19c5-46e7-be0e-0bd9b4564584",
        "name": "Tiger's Lust",
        "shortName": "Lust",
        "specId": "88f4a6b5-7766-41c3-b824-fbba531a2c8e"
      },
      "816c9398-85be-4d6d-b2ff-9e47a9a5a259": {
        "game_id": 288826,
        "icon_name": "spell_druid_stamedingroar",
        "id": "816c9398-85be-4d6d-b2ff-9e47a9a5a259",
        "name": "Improved Stampeding Roar",
        "shortName": "Imp. Roar",
        "specId": "6c233e8c-5bd4-4ece-9fb8-529a1e78759b"
      },
      "85054271-9346-4fb8-befb-d630584f60d8": {
        "game_id": 370511,
        "icon_name": "inv_potion_49",
        "id": "85054271-9346-4fb8-befb-d630584f60d8",
        "name": "HP Pot",
        "shortName": "Pot",
        "specId": "ab48ab5c-dfb9-4ce9-9557-8d0ce5129df2"
      },
      "85688f8c-a893-4da2-8ddd-95440e3ca0f5": {
        "game_id": 322118,
        "icon_name": "ability_monk_dragonkick",
        "id": "85688f8c-a893-4da2-8ddd-95440e3ca0f5",
        "link_suffix": "",
        "name": "Invoke Yu'lon, the Jade Serpent",
        "shortName": "Yulon",
        "specId": "da2dc773-9412-4b11-ab2b-7d06e200b9d3"
      },
      "86967fd5-a1d9-4a28-95ba-4726fbd78e88": {
        "game_id": 32375,
        "icon_name": "spell_arcane_massdispel",
        "id": "86967fd5-a1d9-4a28-95ba-4726fbd78e88",
        "name": "Mass Dispel",
        "shortName": "Mass",
        "specId": "48c27d79-2cc2-4674-bfd0-9a471f6c7ced"
      },
      "86a57591-e264-4ff6-8343-effad90ccf46": {
        "game_id": 123040,
        "icon_name": "spell_shadow_soulleech_3",
        "id": "86a57591-e264-4ff6-8343-effad90ccf46",
        "name": "Mindbender",
        "shortName": "Bender",
        "specId": "67a45712-192e-4916-ad57-d9a13124fea6"
      },
      "92a8ac6f-8d82-497b-a7be-8cb4dfc35493": {
        "game_id": 124974,
        "icon_name": "achievement_zone_feralas",
        "id": "92a8ac6f-8d82-497b-a7be-8cb4dfc35493",
        "name": "Nature's Vigil",
        "shortName": "Vigil",
        "specId": "6c233e8c-5bd4-4ece-9fb8-529a1e78759b"
      },
      "942880fa-5ba3-4a7e-9fc7-66f0c1eaa773": {
        "game_id": 196718,
        "icon_name": "ability_demonhunter_darkness",
        "id": "942880fa-5ba3-4a7e-9fc7-66f0c1eaa773",
        "link_suffix": "",
        "name": "Darkness",
        "shortName": "Dark",
        "specId": "c95c2375-57fa-4ae8-9d55-c2e939b82247"
      },
      "99080003-2bd8-4434-8cf0-06dfc5c689b6": {
        "game_id": 379391,
        "icon_name": "spell_holy_pureofheart",
        "id": "99080003-2bd8-4434-8cf0-06dfc5c689b6",
        "name": "Quickened Invocation",
        "shortName": "Quickened Invocation",
        "specId": "e1af3b62-ddf5-4369-a528-dab8ab94d366"
      },
      "9af98e94-57d6-442f-b31d-8481dc960391": {
        "game_id": 384909,
        "icon_name": "spell_holy_sealofprotection",
        "id": "9af98e94-57d6-442f-b31d-8481dc960391",
        "name": "Improved Blessing of Protection",
        "shortName": "Imp Blessing",
        "specId": "8fceebcc-a93b-4692-81ea-331b2e59d43d"
      },
      "9d3e0934-fd24-4548-8e98-24b15b3a7724": {
        "game_id": 114154,
        "icon_name": "spell_holy_holyguidance",
        "id": "9d3e0934-fd24-4548-8e98-24b15b3a7724",
        "name": "Unbreakable Spirit",
        "shortName": "Unbr",
        "specId": "4ac0a1e4-3352-49e9-b455-faa83312526d"
      },
      "a107c2ad-9fb6-494b-bb2d-9e3eb65ae4ea": {
        "game_id": 200652,
        "icon_name": "inv_mace_2h_artifactsilverhand_d_01",
        "id": "a107c2ad-9fb6-494b-bb2d-9e3eb65ae4ea",
        "name": "Tyr's Deliverance",
        "shortName": "Tyr",
        "specId": "e1af3b62-ddf5-4369-a528-dab8ab94d366"
      },
      "a1190285-e0a2-484c-9471-d4244f4709b9": {
        "game_id": 116841,
        "icon_name": "ability_monk_tigerslust",
        "id": "a1190285-e0a2-484c-9471-d4244f4709b9",
        "name": "Tiger's Lust",
        "shortName": "Lust",
        "specId": "da2dc773-9412-4b11-ab2b-7d06e200b9d3"
      },
      "a1a9d9f5-3e80-42d8-a698-790f5483e233": {
        "game_id": 374383,
        "icon_name": "spell_deathknight_antimagiczone",
        "id": "a1a9d9f5-3e80-42d8-a698-790f5483e233",
        "link_suffix": "",
        "name": "Assimilation",
        "shortName": "Assi",
        "specId": "34735ecf-bf9e-4225-bb6e-ee617b024b70"
      },
      "a53276ad-cac3-4b9c-8d1f-a0799aa72517": {
        "game_id": 406732,
        "icon_name": "ability_evoker_stretchtime",
        "id": "a53276ad-cac3-4b9c-8d1f-a0799aa72517",
        "name": "Spatial Paradox",
        "shortName": "Para",
        "specId": "e6b1de69-ce2c-467c-ae7a-e1613ba23fb9"
      },
      "a7e35d51-0b24-459f-a910-3c171a1f1c2c": {
        "game_id": 374227,
        "icon_name": "ability_evoker_hoverblack",
        "id": "a7e35d51-0b24-459f-a910-3c171a1f1c2c",
        "name": "Zephyr",
        "shortName": "Zeph",
        "specId": "cbfc9a1d-a504-4c56-8887-681e57a87211"
      },
      "a850f1e4-51d9-4019-93a6-1d2fbc9b07f3": {
        "game_id": 391528,
        "icon_name": "ability_ardenweald_druid",
        "id": "a850f1e4-51d9-4019-93a6-1d2fbc9b07f3",
        "name": "Convoke the Spirits",
        "shortName": "Con",
        "specId": "72947601-4270-4e1e-b917-25aacaa6d3e0"
      },
      "aaac0711-6e84-472b-a1c1-652c8f833c60": {
        "game_id": 114154,
        "icon_name": "spell_holy_holyguidance",
        "id": "aaac0711-6e84-472b-a1c1-652c8f833c60",
        "name": "Unbreakable Spirit",
        "shortName": "Unbr",
        "specId": "8fceebcc-a93b-4692-81ea-331b2e59d43d"
      },
      "abdf54fd-3107-4769-a046-45fc47709cf8": {
        "game_id": 421453,
        "icon_name": "ability_priest_ascendance",
        "id": "abdf54fd-3107-4769-a046-45fc47709cf8",
        "name": "Ultimate Penitence",
        "shortName": "Penti",
        "specId": "67a45712-192e-4916-ad57-d9a13124fea6"
      },
      "ac6a2554-4ca1-4af8-9470-a7c35bc006b4": {
        "game_id": 419110,
        "icon_name": "spell_holy_divinehymn",
        "id": "ac6a2554-4ca1-4af8-9470-a7c35bc006b4",
        "link_suffix": "",
        "name": "Seraphic Crescendo",
        "shortName": "Sera",
        "specId": "d122a0b5-d857-4bc5-a456-c7250f8f6690"
      },
      "b0609c1f-80fb-4d7e-8575-748119151e7c": {
        "game_id": 192077,
        "icon_name": "ability_shaman_windwalktotem",
        "id": "b0609c1f-80fb-4d7e-8575-748119151e7c",
        "name": "Wind Rush Totem",
        "shortName": "WRT",
        "specId": "51daa0f0-df16-4983-ae44-e11b5f9b3edb"
      },
      "b1b64ce1-49d1-4fa5-b047-fc83e85a6f49": {
        "game_id": 406732,
        "icon_name": "ability_evoker_stretchtime",
        "id": "b1b64ce1-49d1-4fa5-b047-fc83e85a6f49",
        "name": "Spatial Paradox",
        "shortName": "Para",
        "specId": "48a205f0-5e24-4382-9e0b-3c06cfc1b873"
      },
      "b1e5d8b2-8f03-4c56-87bc-168b78983f05": {
        "game_id": 376210,
        "icon_name": "ability_bossmagistrix_timewarp2",
        "id": "b1e5d8b2-8f03-4c56-87bc-168b78983f05",
        "name": "Erasure",
        "shortName": "Erasure",
        "specId": "48a205f0-5e24-4382-9e0b-3c06cfc1b873"
      },
      "b20ce071-7803-4516-987a-fa837638ecc5": {
        "game_id": 374383,
        "icon_name": "spell_deathknight_antimagiczone",
        "id": "b20ce071-7803-4516-987a-fa837638ecc5",
        "link_suffix": "",
        "name": "Assimilation",
        "shortName": "Assi",
        "specId": "b72fb4f9-413a-4222-8569-b3cb8e5e67f2"
      },
      "b42a618a-6020-4766-8fbb-8427b0589f3e": {
        "game_id": 192077,
        "icon_name": "ability_shaman_windwalktotem",
        "id": "b42a618a-6020-4766-8fbb-8427b0589f3e",
        "name": "Wind Rush Totem",
        "shortName": "WRT",
        "specId": "1df0b300-a31e-4ebc-be57-a909f82bab4b"
      },
      "b46075fb-d3c3-4057-82ee-936233ed4ab1": {
        "game_id": 344359,
        "icon_name": "ability_monk_dpsstance",
        "id": "b46075fb-d3c3-4057-82ee-936233ed4ab1",
        "link_suffix": "?def=129821&rank=2",
        "name": "Ancient Arts (2/2)",
        "shortName": "Arts",
        "specId": "18dad85c-ac2c-4aac-b0f8-e0fc4b8633e6"
      },
      "b6b61f4c-5577-457a-bf54-3547661a4dce": {
        "game_id": 114154,
        "icon_name": "spell_holy_holyguidance",
        "id": "b6b61f4c-5577-457a-bf54-3547661a4dce",
        "name": "Unbreakable Spirit",
        "shortName": "Unbr",
        "specId": "e1af3b62-ddf5-4369-a528-dab8ab94d366"
      },
      "b8dd12bc-a02a-4619-b322-a3443f2ae2c7": {
        "game_id": 382552,
        "icon_name": "spell_druid_ironbark",
        "id": "b8dd12bc-a02a-4619-b322-a3443f2ae2c7",
        "name": "Improved Ironbark",
        "shortName": "Imp. IB",
        "specId": "72947601-4270-4e1e-b917-25aacaa6d3e0"
      },
      "bb8c6b1f-9882-4de1-ba3a-a336b3e2f83e": {
        "game_id": 1022,
        "icon_name": "spell_holy_sealofprotection",
        "id": "bb8c6b1f-9882-4de1-ba3a-a336b3e2f83e",
        "name": "Blessing of Protection",
        "shortName": "BoP",
        "specId": "8fceebcc-a93b-4692-81ea-331b2e59d43d"
      },
      "bf99cae6-ff7b-4020-83c5-01405fe3869f": {
        "game_id": 1022,
        "icon_name": "spell_holy_sealofprotection",
        "id": "bf99cae6-ff7b-4020-83c5-01405fe3869f",
        "name": "Blessing of Protection",
        "shortName": "BoP",
        "specId": "4ac0a1e4-3352-49e9-b455-faa83312526d"
      },
      "bff86c49-be3e-4c8e-98da-39165ff143cf": {
        "game_id": 344359,
        "icon_name": "ability_monk_dpsstance",
        "id": "bff86c49-be3e-4c8e-98da-39165ff143cf",
        "link_suffix": "?def=129821&rank=1",
        "name": "Ancient Arts (1/2)",
        "shortName": "Arts",
        "specId": "88f4a6b5-7766-41c3-b824-fbba531a2c8e"
      },
      "c207d1a2-cfde-4750-b925-21ebeb963f95": {
        "game_id": 381867,
        "icon_name": "spell_nature_agitatingtotem",
        "id": "c207d1a2-cfde-4750-b925-21ebeb963f95",
        "link_suffix": "",
        "name": "Totemic Surge",
        "shortName": "TS",
        "specId": "51daa0f0-df16-4983-ae44-e11b5f9b3edb"
      },
      "c3460d10-12fa-4f28-a400-8aa45a40c075": {
        "game_id": 381867,
        "icon_name": "spell_nature_agitatingtotem",
        "id": "c3460d10-12fa-4f28-a400-8aa45a40c075",
        "link_suffix": "",
        "name": "Totemic Surge",
        "shortName": "TS",
        "specId": "af2ca3dc-34c9-4632-98d2-6ea12a2a72f9"
      },
      "c4fb1719-67a6-40f5-89ed-d11eb98a97f8": {
        "game_id": 388212,
        "icon_name": "inv_pet_jadeserpentpet",
        "id": "c4fb1719-67a6-40f5-89ed-d11eb98a97f8",
        "name": "Gift of the Celestials",
        "shortName": "Gift",
        "specId": "da2dc773-9412-4b11-ab2b-7d06e200b9d3"
      },
      "c50dc21e-810f-40a8-b0d3-2253e8bb292f": {
        "game_id": 102793,
        "icon_name": "spell_druid_ursolsvortex",
        "id": "c50dc21e-810f-40a8-b0d3-2253e8bb292f",
        "link_suffix": "",
        "name": "Ursol's Vortex",
        "shortName": "Vor",
        "specId": "575905ae-cdc7-44c8-946c-861d50111b6d"
      },
      "c51067a1-5b8b-4e69-a1fe-fba2b257a695": {
        "game_id": 16191,
        "icon_name": "ability_shaman_manatidetotem",
        "id": "c51067a1-5b8b-4e69-a1fe-fba2b257a695",
        "name": "Mana Tide Totem",
        "shortName": "MTT",
        "specId": "51daa0f0-df16-4983-ae44-e11b5f9b3edb"
      },
      "c5c5d3c7-4bb0-45d7-b7e7-13d3b945a3fd": {
        "game_id": 384909,
        "icon_name": "spell_holy_sealofprotection",
        "id": "c5c5d3c7-4bb0-45d7-b7e7-13d3b945a3fd",
        "name": "Improved Blessing of Protection",
        "shortName": "Imp Blessing",
        "specId": "4ac0a1e4-3352-49e9-b455-faa83312526d"
      },
      "c788d9cb-8e85-432b-8ec4-763fc36d75bd": {
        "game_id": 370665,
        "icon_name": "ability_evoker_flywithme",
        "id": "c788d9cb-8e85-432b-8ec4-763fc36d75bd",
        "name": "Rescue",
        "shortName": "Resc",
        "specId": "48a205f0-5e24-4382-9e0b-3c06cfc1b873"
      },
      "cac23db6-fdaa-4d74-874f-ef7e48f654a3": {
        "game_id": 374968,
        "icon_name": "ability_evoker_timespiral",
        "id": "cac23db6-fdaa-4d74-874f-ef7e48f654a3",
        "name": "Time Spiral",
        "shortName": "Spiral",
        "specId": "cbfc9a1d-a504-4c56-8887-681e57a87211"
      },
      "d00ae128-a28d-45d4-a73a-933972f4d8e7": {
        "game_id": 114052,
        "icon_name": "spell_fire_elementaldevastation",
        "id": "d00ae128-a28d-45d4-a73a-933972f4d8e7",
        "name": "Ascendance",
        "shortName": "Asc",
        "specId": "51daa0f0-df16-4983-ae44-e11b5f9b3edb"
      },
      "d12ab590-e070-4499-a46b-8f8d9f6d87f9": {
        "game_id": 370665,
        "icon_name": "ability_evoker_flywithme",
        "id": "d12ab590-e070-4499-a46b-8f8d9f6d87f9",
        "name": "Rescue",
        "shortName": "Resc",
        "specId": "cbfc9a1d-a504-4c56-8887-681e57a87211"
      },
      "d3313379-f52e-4693-8d02-2ff8414771e2": {
        "game_id": 374227,
        "icon_name": "ability_evoker_hoverblack",
        "id": "d3313379-f52e-4693-8d02-2ff8414771e2",
        "name": "Zephyr",
        "shortName": "Zeph",
        "specId": "48a205f0-5e24-4382-9e0b-3c06cfc1b873"
      },
      "d51b0c37-a48f-4c9c-ab59-5056cccd2c97": {
        "game_id": 383269,
        "icon_name": "ability_maldraxxus_deathknight",
        "id": "d51b0c37-a48f-4c9c-ab59-5056cccd2c97",
        "link_suffix": "",
        "name": "Abomination Limb",
        "shortName": "Abom",
        "specId": "1b478900-c50e-49f6-b9b1-d2fedfb10c2b"
      },
      "d635d8b8-1c98-41c9-8ee2-67f9e427b23c": {
        "game_id": 31884,
        "icon_name": "spell_holy_avenginewrath",
        "id": "d635d8b8-1c98-41c9-8ee2-67f9e427b23c",
        "link_suffix": "",
        "name": "Avenging Wrath",
        "shortName": "Wings",
        "specId": "e1af3b62-ddf5-4369-a528-dab8ab94d366"
      },
      "d85b4fbd-e95e-4f19-be78-5060b4ed84dd": {
        "game_id": 383011,
        "icon_name": "ability_shaman_multitotemactivation",
        "id": "d85b4fbd-e95e-4f19-be78-5060b4ed84dd",
        "link_suffix": "",
        "name": "Call of the Elements",
        "shortName": "CotE",
        "specId": "51daa0f0-df16-4983-ae44-e11b5f9b3edb"
      },
      "db125588-e68c-4063-9294-3b24618a0e06": {
        "game_id": 406732,
        "icon_name": "ability_evoker_stretchtime",
        "id": "db125588-e68c-4063-9294-3b24618a0e06",
        "name": "Spatial Paradox",
        "shortName": "Para",
        "specId": "cbfc9a1d-a504-4c56-8887-681e57a87211"
      },
      "dbd77078-c13d-4698-9837-255c458b30dd": {
        "game_id": 73325,
        "icon_name": "priest_spell_leapoffaith_a",
        "id": "dbd77078-c13d-4698-9837-255c458b30dd",
        "name": "Leap of Faith",
        "shortName": "Leap",
        "specId": "67a45712-192e-4916-ad57-d9a13124fea6"
      },
      "dcc7c4b8-754b-48bf-b32b-f7962a361640": {
        "game_id": 207399,
        "icon_name": "spell_nature_reincarnation",
        "id": "dcc7c4b8-754b-48bf-b32b-f7962a361640",
        "name": "Ancestral Protection Totem",
        "shortName": "APT",
        "specId": "51daa0f0-df16-4983-ae44-e11b5f9b3edb"
      },
      "ddf5e9b4-563c-489c-9e2c-969ef9137d90": {
        "game_id": 383269,
        "icon_name": "ability_maldraxxus_deathknight",
        "id": "ddf5e9b4-563c-489c-9e2c-969ef9137d90",
        "link_suffix": "",
        "name": "Abomination Limb",
        "shortName": "Abom",
        "specId": "34735ecf-bf9e-4225-bb6e-ee617b024b70"
      },
      "e0ed8a5e-e384-490e-bae8-b0bbe94ccf3f": {
        "game_id": 374968,
        "icon_name": "ability_evoker_timespiral",
        "id": "e0ed8a5e-e384-490e-bae8-b0bbe94ccf3f",
        "name": "Time Spiral",
        "shortName": "Spiral",
        "specId": "48a205f0-5e24-4382-9e0b-3c06cfc1b873"
      },
      "e18bbe7e-148c-4b9a-b04b-4e55e3bde3af": {
        "game_id": 373905,
        "icon_name": "ability_vehicle_shellshieldgenerator_green",
        "id": "e18bbe7e-148c-4b9a-b04b-4e55e3bde3af",
        "name": "Personal 2min",
        "shortName": "Pers",
        "specId": "ab48ab5c-dfb9-4ce9-9557-8d0ce5129df2"
      },
      "e30f64db-ddce-4fee-8770-e0db405b5e02": {
        "game_id": 6940,
        "icon_name": "spell_holy_sealofsacrifice",
        "id": "e30f64db-ddce-4fee-8770-e0db405b5e02",
        "name": "Blessing of Sacrifice",
        "shortName": "Sac",
        "specId": "4ac0a1e4-3352-49e9-b455-faa83312526d"
      },
      "e4110ee3-e5be-4e09-aa25-e580a7b09d97": {
        "game_id": 73325,
        "icon_name": "priest_spell_leapoffaith_a",
        "id": "e4110ee3-e5be-4e09-aa25-e580a7b09d97",
        "name": "Leap of Faith",
        "shortName": "Leap",
        "specId": "48c27d79-2cc2-4674-bfd0-9a471f6c7ced"
      },
      "e7212970-f5d7-4249-80a0-a32a19a13c9a": {
        "game_id": 33891,
        "icon_name": "ability_druid_improvedtreeform",
        "id": "e7212970-f5d7-4249-80a0-a32a19a13c9a",
        "name": "Incarnation: Tree of Life",
        "shortName": "Tree",
        "specId": "72947601-4270-4e1e-b917-25aacaa6d3e0"
      },
      "e9241746-c3b9-48f3-8f59-3e44529f8c44": {
        "game_id": 389783,
        "icon_name": "sha_spell_warlock_demonsoul",
        "id": "e9241746-c3b9-48f3-8f59-3e44529f8c44",
        "name": "Pitch Black",
        "shortName": "Pitch",
        "specId": "08853913-0c47-4ca1-aec0-e93206a6ee45"
      },
      "ec0aae17-7c9c-4335-9bbe-54e56e5deb9b": {
        "game_id": 199855,
        "icon_name": "achievement_boss_lanathel",
        "id": "ec0aae17-7c9c-4335-9bbe-54e56e5deb9b",
        "name": "San'layn",
        "shortName": "San",
        "specId": "48c27d79-2cc2-4674-bfd0-9a471f6c7ced"
      },
      "ee0197a0-eea0-4861-a223-c460b28c64a7": {
        "game_id": 390620,
        "icon_name": "ability_priest_savinggrace",
        "id": "ee0197a0-eea0-4861-a223-c460b28c64a7",
        "name": "Move with Grace",
        "shortName": "Grace",
        "specId": "67a45712-192e-4916-ad57-d9a13124fea6"
      },
      "ef60d47b-0057-4d36-b70e-2da0c78f7f60": {
        "game_id": 108199,
        "icon_name": "ability_deathknight_aoedeathgrip",
        "id": "ef60d47b-0057-4d36-b70e-2da0c78f7f60",
        "link_suffix": "",
        "name": "Gorefiend's Grasp",
        "shortName": "Grasp",
        "specId": "34735ecf-bf9e-4225-bb6e-ee617b024b70"
      },
      "f2af9c45-0654-4dea-bbff-1f1272279129": {
        "game_id": 6940,
        "icon_name": "spell_holy_sealofsacrifice",
        "id": "f2af9c45-0654-4dea-bbff-1f1272279129",
        "name": "Blessing of Sacrifice",
        "shortName": "Sac",
        "specId": "8fceebcc-a93b-4692-81ea-331b2e59d43d"
      },
      "f4826595-8556-48d2-bd8d-1d65d16cfb10": {
        "game_id": 344359,
        "icon_name": "ability_monk_dpsstance",
        "id": "f4826595-8556-48d2-bd8d-1d65d16cfb10",
        "link_suffix": "?def=129821&rank=2",
        "name": "Ancient Arts (2/2)",
        "shortName": "Arts",
        "specId": "da2dc773-9412-4b11-ab2b-7d06e200b9d3"
      },
      "fbd06f55-71cc-422f-b03e-8b1a2bb50980": {
        "game_id": 378425,
        "icon_name": "spell_holy_greaterblessingofsalvation",
        "id": "fbd06f55-71cc-422f-b03e-8b1a2bb50980",
        "link_suffix": "?def=107474&rank=1",
        "name": "Uther's Counsel (1/2)",
        "shortName": "Counsel",
        "specId": "8fceebcc-a93b-4692-81ea-331b2e59d43d"
      },
      "fbed7388-e41a-4a31-9c97-6f4aa5fbec72": {
        "game_id": 392911,
        "icon_name": "spell_holy_fanaticism",
        "id": "fbed7388-e41a-4a31-9c97-6f4aa5fbec72",
        "name": "Unwavering Spirit",
        "shortName": "Spirit",
        "specId": "e1af3b62-ddf5-4369-a528-dab8ab94d366"
      },
      "feafa380-c709-4caf-8764-32653034cacd": {
        "game_id": 266921,
        "icon_name": "ability_hunter_aspectoftheviper",
        "id": "feafa380-c709-4caf-8764-32653034cacd",
        "name": "Born To Be Wild",
        "shortName": "BtbW",
        "specId": "2fed59fd-6bdc-4b4e-a7d6-70c70cf8a5aa"
      }
    }
  }`)
